var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeAnimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-knowledge:not(.animated) .animable {opacity: 0;}svg#freepik_stories-knowledge.animated #freepik--background-complete--inject-15 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-knowledge.animated #freepik--Icons--inject-15 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-knowledge.animated #freepik--Globe--inject-15 {animation: 1.5s Infinite  linear heartbeat;animation-delay: 0s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "252.065px 261.986px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "255.05 453.57 254.68 421.1 272.36 421.1 272.97 453.57",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "263.825px 437.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.32,426.87c0,.2-3.68.37-8.22.37s-8.21-.17-8.21-.37,3.68-.36,8.21-.36S271.32,426.68,271.32,426.87Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "263.105px 426.875px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.32,431.89c0,.2-3.68.36-8.22.36s-8.21-.16-8.21-.36,3.68-.36,8.21-.36S271.32,431.69,271.32,431.89Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "263.105px 431.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.32,436.9c0,.2-3.68.36-8.22.36s-8.21-.16-8.21-.36,3.68-.36,8.21-.36S271.32,436.7,271.32,436.9Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "263.105px 436.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.32,441.91c0,.2-3.68.36-8.22.36s-8.21-.16-8.21-.36,3.68-.36,8.21-.36S271.32,441.71,271.32,441.91Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "263.105px 441.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.32,446.93c0,.2-3.68.36-8.22.36s-8.21-.16-8.21-.36,3.68-.37,8.21-.37S271.32,446.73,271.32,446.93Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "263.105px 446.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M253.75,420.24H449.69c2.42,10.75,2.08,22.59,0,35.1H254.58V453H266.5a5.63,5.63,0,0,0,5.63-5.63V427.9a5.63,5.63,0,0,0-5.63-5.63H253.75Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "352.565px 437.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M300.07,437.81h3.27a.73.73,0,0,1,.35.09.66.66,0,0,1,.35.61,1.06,1.06,0,0,1,0,.21c-.07.28-.14.56-.22.84a9.34,9.34,0,0,1-2.05,3.7A3.87,3.87,0,0,1,299,444.7l-.39,0a3.23,3.23,0,0,1-2.23-1.61,7.35,7.35,0,0,1-1-3.94,10.85,10.85,0,0,1,.38-2.8,9.4,9.4,0,0,1,1.95-3.79,3.93,3.93,0,0,1,2.94-1.57,2.78,2.78,0,0,1,1.24.28,4,4,0,0,1,1.91,2.39.76.76,0,0,1,.08.33.64.64,0,0,1-.1.35.67.67,0,0,1-.61.35.6.6,0,0,1-.22,0,.63.63,0,0,1-.44-.44l0-.06a3.7,3.7,0,0,0-.39-.77,1.86,1.86,0,0,0-1.57-.94,1.79,1.79,0,0,0-1.08.4,5.69,5.69,0,0,0-1.78,2.56,9.6,9.6,0,0,0-.78,3.69,6.69,6.69,0,0,0,.56,2.9,1.92,1.92,0,0,0,1.71,1.28,2.33,2.33,0,0,0,1.58-.95,8.66,8.66,0,0,0,1.68-3c-1.51,0-2.29,0-2.35,0-.51-.08-.77-.34-.78-.79a.88.88,0,0,1,.07-.23A.74.74,0,0,1,300.07,437.81Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "299.711px 437.845px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M311.19,431.43a1.54,1.54,0,0,1,.09.24q.21.72,2.31,12.14a.51.51,0,0,1,0,.17.77.77,0,0,1-.09.36.66.66,0,0,1-.59.36h-.11a.63.63,0,0,1-.54-.48l-.78-4h-4l-1.93,4-.07.14a.76.76,0,0,1-.6.34.7.7,0,0,1-.38-.11.69.69,0,0,1-.33-.59.54.54,0,0,1,.05-.21c.12-.28.32-.73.6-1.33q4.21-9.22,5.05-10.89a.76.76,0,0,1,.68-.49A.71.71,0,0,1,311.19,431.43Zm-.87,2.71-2.18,4.58h3.07Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "308.884px 437.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M322.12,444.7h-5.9a.73.73,0,0,1-.38-.11,1.07,1.07,0,0,1-.33-.74h0q0-.36,1.63-12.09a1.09,1.09,0,0,1,0-.26.64.64,0,0,1,.64-.43.72.72,0,0,1,.32.08.65.65,0,0,1,.37.62c-.05.54-.18,1.64-.4,3.32q-1,7.74-1.06,8.17h5a1,1,0,0,1,.38.07.66.66,0,0,1,.45.66.62.62,0,0,1,0,.23A.82.82,0,0,1,322.12,444.7Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "319.18px 437.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M330.2,431.43a1.54,1.54,0,0,1,.09.24q.19.72,2.3,12.14a.53.53,0,0,1,0,.17.78.78,0,0,1-.1.36.65.65,0,0,1-.59.36h-.11a.63.63,0,0,1-.54-.48l-.78-4h-4l-1.94,4a.84.84,0,0,1-.06.14.79.79,0,0,1-.61.34.73.73,0,0,1-.38-.11.68.68,0,0,1-.32-.59.52.52,0,0,1,0-.21c.12-.28.32-.73.6-1.33q4.23-9.22,5.05-10.89a.76.76,0,0,1,.68-.49A.73.73,0,0,1,330.2,431.43Zm-.88,2.71-2.18,4.58h3.08Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "327.873px 437.888px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M339.61,438.4c.46,1.28.81,2.26,1.07,3,.6,1.68.91,2.57.91,2.66a.66.66,0,0,1-.11.36.69.69,0,0,1-.59.32.63.63,0,0,1-.59-.47,3,3,0,0,0-.11-.3c-.32-.74-.85-2.12-1.58-4.16l-3.34,4.56a.73.73,0,0,1-1,.28A.67.67,0,0,1,334,444v-.15a1.7,1.7,0,0,1,.36-.57c1.12-1.45,2.35-3.18,3.71-5.18-.15-.39-.28-.76-.41-1.11-1.26-3.37-1.88-5.11-1.88-5.22a.86.86,0,0,1,.08-.36.63.63,0,0,1,.58-.35.68.68,0,0,1,.65.39l2,5.31,3.93-5.36a.77.77,0,0,1,.63-.33.62.62,0,0,1,.33.08.66.66,0,0,1,.34.62,1.09,1.09,0,0,1-.07.33Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "339.156px 437.903px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M354.22,431.12a.8.8,0,0,1,.33.08.72.72,0,0,1,.38.61q-1.46,11.44-1.6,12.37a7.68,7.68,0,0,1-1.27,3.23,4.59,4.59,0,0,1-3.92,1.92,4.52,4.52,0,0,1-1.89-.5,4.18,4.18,0,0,1-2.08-1.83.66.66,0,0,1-.08-.34.73.73,0,0,1,.09-.35.7.7,0,0,1,.61-.35.68.68,0,0,1,.54.29,3.78,3.78,0,0,0,3,1.72,3,3,0,0,0,2.35-1.19,6.52,6.52,0,0,0,1.3-3.71,3.61,3.61,0,0,1-.87.92,3.56,3.56,0,0,1-2.12.69,2.75,2.75,0,0,1-.4,0,3.19,3.19,0,0,1-2.24-1.61,7.35,7.35,0,0,1-1-3.94c0-.71,0-1.45.1-2.21.11-1.2.37-2.9.8-5.09a.83.83,0,0,1,.06-.21.64.64,0,0,1,.63-.48.61.61,0,0,1,.34.1.6.6,0,0,1,.35.56,24.18,24.18,0,0,1-.32,2.69,37.6,37.6,0,0,0-.47,4.12,8.25,8.25,0,0,0,.53,3.2c.4,1,1,1.44,1.75,1.44l.24,0a3.22,3.22,0,0,0,1.76-1.42,8.59,8.59,0,0,0,1.46-3.25l.9-6.73a.75.75,0,0,1,.09-.3A.64.64,0,0,1,354.22,431.12Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "349.51px 440.226px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m442.33 455.8c-0.2 0-0.36-8.07-0.36-18s0.16-18 0.36-18 0.36 8.06 0.36 18-0.16 18-0.36 18z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "442.33px 437.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M282,455.8c-.2,0-.36-8.07-.36-18s.16-18,.36-18,.36,8.06.36,18S282.19,455.8,282,455.8Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "282px 437.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M445.77,455.8c-.2,0-.36-8.07-.36-18s.16-18,.36-18,.36,8.06.36,18S446,455.8,445.77,455.8Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "445.77px 437.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M278.78,455.8c-.2,0-.37-8.07-.37-18s.17-18,.37-18,.36,8.06.36,18S279,455.8,278.78,455.8Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "278.775px 437.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.82,425.71l0-.06,20.71,16.71.18.15-.22.06-2.76.72-17.49,4.59h-.06l-15.85-6.73-4.49-1.92-1.18-.51-.3-.14-.1-.05.1,0,.31.12,1.2.49,4.51,1.87,15.88,6.64h-.07l17.48-4.61,2.75-.72,0,.2-20.67-16.76,0,0v0",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.485px 436.765px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "413.63 439.76 414.76 440.82 416.27 440.49 415.61 441.89 416.39 443.24 414.85 443.04 413.82 444.19 413.53 442.67 412.11 442.05 413.47 441.3",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "414.25px 441.975px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "393.76 446.34 394.53 446.99 395.5 446.71 395.13 447.65 395.68 448.48 394.68 448.41 394.06 449.2 393.81 448.23 392.87 447.88 393.72 447.35",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.275px 447.77px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "371.82 437.34 373.05 437.42 373.81 436.45 374.12 437.64 375.27 438.06 374.23 438.72 374.19 439.95 373.24 439.17 372.05 439.51 372.51 438.36",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "373.545px 438.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "422.91 425.98 424.14 426.05 424.9 425.08 425.21 426.28 426.37 426.7 425.32 427.36 425.28 428.59 424.33 427.81 423.15 428.14 423.6 427",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "424.64px 426.835px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "393.82 425.17 394.6 425.22 395.09 424.6 395.28 425.36 396.02 425.63 395.36 426.05 395.33 426.84 394.72 426.34 393.97 426.55 394.25 425.82",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "394.92px 425.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.64,426.84c0,.08-6.7-.14-15-.5s-15-.7-14.95-.78,6.7.14,15,.49S424.64,426.76,424.64,426.84Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "409.665px 426.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m432.16 419.93h-198.73c-2.6-5.9-3.24-11.51 0-16.54h198.73c2.61 6.02 2.39 11.49 0 16.54z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "332.635px 411.66px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 274.58,
    y: 408.12,
    width: 107.67,
    height: 6.02,
    fill: "#ebebeb",
    style: {
      transformOrigin: "328.415px 411.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m241.06 420a5.82 5.82 0 0 1-1.57-2 14.63 14.63 0 0 1-1.05-12 5.72 5.72 0 0 1 1.2-2.24 22.5 22.5 0 0 1-0.71 2.4 16.67 16.67 0 0 0 1 11.57 18.37 18.37 0 0 1 1.13 2.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "239.338px 411.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m245.36 420a5.82 5.82 0 0 1-1.57-2 14.63 14.63 0 0 1-1-12 5.72 5.72 0 0 1 1.2-2.24 22.5 22.5 0 0 1-0.71 2.4 16.67 16.67 0 0 0 1 11.57 18.37 18.37 0 0 1 1.08 2.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "243.654px 411.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m424.12 419.63c-0.22-0.07 1.41-3.52 1.4-8.08s-1.52-8-1.3-8.11 2.08 3.35 2 8.11-1.97 8.2-2.1 8.08z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "425.161px 411.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m420.42 419.59c-0.21 0 0.62-3.54 0.6-7.92s-0.83-7.86-0.62-7.92 1.35 3.43 1.34 7.92-1.15 7.99-1.32 7.92z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "421.053px 411.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m269.65 157.68-1.07 2.38s15 1.17 20.42 8.76a1.82 1.82 0 0 0 0.84 1.48l2.92 1.85a1.78 1.78 0 0 0 2-0.12 20 20 0 0 1 14.56 8.15l2.19 2.77 9.55-32.29-31.74-24.89z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "294.82px 154.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m269.36 153.41-2 4.23s15.95-1 24.31 12.81l7.21-21.64s-26.41 0.83-29.52 4.6z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "283.12px 159.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m282.6 122s20.4-3.7 23.4 17.72l-14.38 30.73s-6.39-20.47-24.1-16.85z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "286.76px 146.103px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m291.63 170.45s16.76-1.54 21.49 11.68l11.54-28.89-19.15-12.46z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "308.145px 161.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M306,139.73s9.38-7.5,18.13-1.79l5.51,3.85-11.07,29.29s-13.65-9.13-26.95-.61Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "310.63px 153.438px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M291.63,170.45a6.45,6.45,0,0,1,.47-1.24l1.48-3.31,5-10.85c1.93-4.19,3.67-8,5-10.86l1.51-3.29a5.81,5.81,0,0,1,.62-1.18,7.37,7.37,0,0,1-.42,1.27c-.3.8-.77,1.95-1.36,3.36-1.18,2.82-2.9,6.69-4.86,10.93s-3.79,8.05-5.15,10.79c-.68,1.37-1.24,2.47-1.64,3.23A6.21,6.21,0,0,1,291.63,170.45Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "298.67px 155.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M324.12,144.73c-.06.08-.9-.57-2.41-1.31a17.25,17.25,0,0,0-12.8-1c-1.61.51-2.54,1-2.58.94s.19-.19.61-.44a10.78,10.78,0,0,1,1.84-.87,15.63,15.63,0,0,1,6.66-.93,15.84,15.84,0,0,1,6.45,1.92,10.72,10.72,0,0,1,1.69,1.14C324,144.52,324.14,144.7,324.12,144.73Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "315.224px 142.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M323.28,148.27c-.06.08-.9-.57-2.42-1.32a17.22,17.22,0,0,0-12.79-1c-1.61.51-2.54,1-2.59.94s.2-.19.61-.44a11,11,0,0,1,1.85-.87,15.84,15.84,0,0,1,13.11,1,11.46,11.46,0,0,1,1.69,1.14C323.11,148.05,323.3,148.24,323.28,148.27Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "314.378px 146.443px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M321.7,151.78c-.06.08-.9-.57-2.41-1.31a17.25,17.25,0,0,0-12.8-1c-1.61.51-2.53,1-2.58.94s.2-.19.61-.44a11.17,11.17,0,0,1,1.84-.87,15.65,15.65,0,0,1,6.67-.93,15.84,15.84,0,0,1,6.44,1.92,11.41,11.41,0,0,1,1.7,1.14C321.54,151.57,321.73,151.75,321.7,151.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "312.803px 149.954px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320.72,155.3c-.06.08-.9-.57-2.42-1.32a17.22,17.22,0,0,0-12.79-1c-1.61.51-2.54,1-2.59.94s.2-.19.61-.44a11,11,0,0,1,1.85-.87,15.84,15.84,0,0,1,13.11,1,11.46,11.46,0,0,1,1.69,1.14C320.55,155.08,320.74,155.27,320.72,155.3Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "311.818px 153.473px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.74,159c-.06.08-.9-.57-2.41-1.32a17.38,17.38,0,0,0-12.8-1c-1.61.51-2.54,1-2.58.94s.19-.18.61-.43a10.69,10.69,0,0,1,1.84-.88,15.84,15.84,0,0,1,13.11,1,10.65,10.65,0,0,1,1.69,1.15C319.57,158.82,319.77,159,319.74,159Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "310.844px 157.173px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M318.79,163.28c-.07.08-1-.63-2.64-1.41a19.91,19.91,0,0,0-3-1.14,24.53,24.53,0,0,0-3.87-.77,23.82,23.82,0,0,0-3.93-.08,18.87,18.87,0,0,0-3.17.52c-1.78.46-2.79,1-2.84.95s.22-.2.68-.46a5.32,5.32,0,0,1,.86-.42,7.64,7.64,0,0,1,1.19-.45,16.12,16.12,0,0,1,3.23-.65,21.1,21.1,0,0,1,4,0,22.29,22.29,0,0,1,4,.83,18.06,18.06,0,0,1,3,1.28,11.28,11.28,0,0,1,1.09.64,7.43,7.43,0,0,1,.77.56C318.6,163.05,318.81,163.25,318.79,163.28Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "309.063px 161.281px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M317.38,166.36c-.06.08-1-.64-2.65-1.39a19.44,19.44,0,0,0-3.05-1.07,23,23,0,0,0-7.87-.6,19.5,19.5,0,0,0-3.17.6c-1.78.49-2.79,1.07-2.84,1s.22-.19.68-.46a6.22,6.22,0,0,1,.86-.43,10.28,10.28,0,0,1,1.19-.46,16.93,16.93,0,0,1,3.23-.72,23.33,23.33,0,0,1,4.05-.1,22.3,22.3,0,0,1,4,.71,17.06,17.06,0,0,1,3.09,1.2,9.74,9.74,0,0,1,1.1.64,5.1,5.1,0,0,1,.79.55C317.2,166.13,317.41,166.33,317.38,166.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "307.588px 164.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M291.36,160.51c-.09,0-.28-1.16-1-2.91a15.52,15.52,0,0,0-10.86-9.18c-1.85-.44-3.05-.43-3-.53a2.54,2.54,0,0,1,.84-.08,13.32,13.32,0,0,1,2.28.22,14.91,14.91,0,0,1,6.82,3.24,14.7,14.7,0,0,1,4.32,6.18,11.41,11.41,0,0,1,.6,2.22A2,2,0,0,1,291.36,160.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "283.952px 154.157px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293.12,156.52c-.1,0-.29-1.17-1-2.92a15.52,15.52,0,0,0-10.86-9.18c-1.85-.43-3.05-.42-3.05-.52a2.6,2.6,0,0,1,.84-.08,12.46,12.46,0,0,1,2.29.22,14.7,14.7,0,0,1,11.14,9.42,12.83,12.83,0,0,1,.6,2.22A2.56,2.56,0,0,1,293.12,156.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "285.674px 150.167px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294.87,152.52c-.09,0-.28-1.16-1-2.91A15.47,15.47,0,0,0,283,140.43c-1.85-.44-3.05-.43-3-.52s.29-.08.84-.08a11.48,11.48,0,0,1,2.28.22,14.75,14.75,0,0,1,11.15,9.41,12.2,12.2,0,0,1,.59,2.22C294.9,152.22,294.91,152.52,294.87,152.52Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "287.447px 146.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.63,148.53c-.1,0-.28-1.17-1-2.92a15.54,15.54,0,0,0-10.86-9.17c-1.85-.44-3.05-.43-3.05-.53a2.6,2.6,0,0,1,.84-.08,13.42,13.42,0,0,1,2.29.22A14.7,14.7,0,0,1,296,145.47a12.83,12.83,0,0,1,.6,2.22A2.56,2.56,0,0,1,296.63,148.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "289.186px 142.177px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M298.39,144.53c-.1,0-.29-1.16-1-2.91a15.47,15.47,0,0,0-10.86-9.18c-1.85-.43-3.05-.42-3-.52a2,2,0,0,1,.84-.08,11.48,11.48,0,0,1,2.28.22,14.74,14.74,0,0,1,11.15,9.42,11.94,11.94,0,0,1,.59,2.21A2.44,2.44,0,0,1,298.39,144.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "290.977px 138.178px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M300.14,140.54c-.1,0-.28-1.16-1-2.91a15.52,15.52,0,0,0-10.86-9.18c-1.85-.44-3.05-.43-3.05-.53a2.6,2.6,0,0,1,.84-.08,13.42,13.42,0,0,1,2.29.22,14.75,14.75,0,0,1,11.14,9.42,13.06,13.06,0,0,1,.6,2.22A2,2,0,0,1,300.14,140.54Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "292.699px 134.187px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M64,252.47l.19-.12c.13-.08.32-.18.57-.34a20.66,20.66,0,0,0,2.07-1.48,17.49,17.49,0,0,0,2.81-2.87A16.53,16.53,0,0,0,72.12,243a54.36,54.36,0,0,0,1.56-6.28,26.92,26.92,0,0,1,2.43-7,24.65,24.65,0,0,1,5-6.56A22.64,22.64,0,0,1,97.23,217a21.37,21.37,0,0,1,8,1.76c2.42,1,4.59,2.25,6.74,3.14a17.73,17.73,0,0,0,6.24,1.48,17.21,17.21,0,0,0,9-2.07c.5-.25.9-.53,1.27-.75s.65-.44.88-.62l.52-.41.18-.13-.16.15-.51.43c-.23.19-.53.39-.87.65s-.76.51-1.26.77a17.22,17.22,0,0,1-9,2.17,18,18,0,0,1-6.31-1.47c-2.17-.89-4.35-2.1-6.76-3.12a21.48,21.48,0,0,0-7.94-1.73,22.39,22.39,0,0,0-16,6.11,24.6,24.6,0,0,0-4.92,6.48,27,27,0,0,0-2.43,7,53.85,53.85,0,0,1-1.59,6.29,16.28,16.28,0,0,1-2.58,4.69,17,17,0,0,1-2.85,2.86,20.09,20.09,0,0,1-2.11,1.45l-.59.31Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "97.03px 234.731px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M52.75,234.07A29.41,29.41,0,0,1,56,232.66a27.11,27.11,0,0,1,3.94-1.18,15.68,15.68,0,0,1,5.44-.3,9.52,9.52,0,0,1,1.53.33c.51.16,1,.35,1.53.55l3.18,1.29c2.2.89,4.54,1.86,7,2.77a24.35,24.35,0,0,0,8.16,1.42,21.5,21.5,0,0,0,8.69-1.78,19.77,19.77,0,0,0,7.09-5.31,17.69,17.69,0,0,0,3.72-7.35c.6-2.59.73-5.13,1.19-7.47a17.52,17.52,0,0,1,.91-3.33,16.33,16.33,0,0,1,5.12-6.86,16.2,16.2,0,0,1,3.53-2.13,14.9,14.9,0,0,1,2.46-.84l.66-.15.22,0-.22.07-.65.17a16,16,0,0,0-2.43.89,15.55,15.55,0,0,0-3.48,2.15,17,17,0,0,0-3.6,4,15.4,15.4,0,0,0-1.42,2.81,18.22,18.22,0,0,0-.89,3.29c-.44,2.32-.56,4.87-1.17,7.49a17.71,17.71,0,0,1-3.76,7.46A19.83,19.83,0,0,1,95.59,236a21.74,21.74,0,0,1-8.8,1.8,24.58,24.58,0,0,1-8.24-1.45c-2.52-.92-4.86-1.9-7-2.8l-3.18-1.3c-.51-.21-1-.4-1.51-.56a11.51,11.51,0,0,0-1.5-.33,15.93,15.93,0,0,0-5.38.26A29.81,29.81,0,0,0,56,232.76c-1.06.38-1.86.73-2.41,1L53,234Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "86.56px 220.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.54 231.84c0.06 0 1.33 2.09 2.82 4.76s2.64 4.86 2.64 4.89-1.33-2.1-2.82-4.76-2.7-4.86-2.64-4.89z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "70.2689px 236.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m62.47 231.32c0.07 0 1.74 3.49 3.74 7.86s3.56 7.94 3.5 8-1.71-3.51-3.71-7.89-3.59-7.94-3.53-7.97z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "66.09px 239.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m57.23 232.27c0.06 0 2 4.22 4.4 9.49s4.23 9.57 4.16 9.6-2-4.22-4.4-9.49-4.23-9.57-4.16-9.6z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "61.51px 241.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m100.66 217.45c0.07 0 1 2.37 2.07 5.35s1.9 5.41 1.83 5.43-1-2.37-2.07-5.34-1.9-5.41-1.83-5.44z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.61px 222.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.44,217.43a2.57,2.57,0,0,1,.31.59c.18.38.43.95.74,1.65.6,1.41,1.4,3.37,2.22,5.55s1.49,4.19,2,5.65c.23.73.41,1.32.52,1.74a3,3,0,0,1,.16.64,2.51,2.51,0,0,1-.25-.61l-.61-1.71c-.51-1.44-1.21-3.43-2-5.62s-1.58-4.15-2.15-5.57l-.65-1.68A4,4,0,0,1,93.44,217.43Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "96.415px 225.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.2,219.23a3.43,3.43,0,0,1,.26.69c.17.5.38,1.15.64,1.92.54,1.63,1.3,3.86,2.21,6.3s1.8,4.63,2.46,6.21c.31.76.58,1.38.78,1.87a5.1,5.1,0,0,1,.26.7,4.32,4.32,0,0,1-.35-.66c-.22-.43-.51-1-.86-1.83-.7-1.57-1.62-3.75-2.54-6.19s-1.65-4.7-2.14-6.34c-.24-.82-.43-1.49-.55-2A3.46,3.46,0,0,1,87.2,219.23Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "90.505px 228.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.62,224a2.5,2.5,0,0,1,.24.53c.16.39.36.88.58,1.45.49,1.22,1.17,2.91,2,4.77s1.52,3.52,2.06,4.72l.63,1.43a3,3,0,0,1,.21.54A2.38,2.38,0,0,1,87,237c-.17-.33-.42-.81-.71-1.4-.58-1.18-1.35-2.84-2.13-4.7s-1.44-3.56-1.88-4.81c-.22-.62-.39-1.13-.5-1.48A2.34,2.34,0,0,1,81.62,224Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "84.48px 230.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m77.25 227.71a45.9 45.9 0 0 1 2 4.51 46 46 0 0 1 1.75 4.61 45.9 45.9 0 0 1-2-4.51 47.11 47.11 0 0 1-1.75-4.61z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "79.125px 232.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.24,210.4a3,3,0,0,1,.22.47l.53,1.3,1.73,4.31c.68,1.65,1.29,3.13,1.76,4.3.21.5.38.94.53,1.3a1.83,1.83,0,0,1,.16.49,2.38,2.38,0,0,1-.25-.45c-.15-.3-.36-.73-.61-1.27-.49-1.08-1.15-2.59-1.83-4.27s-1.26-3.22-1.66-4.34c-.2-.56-.35-1-.45-1.33A1.82,1.82,0,0,1,109.24,210.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "111.705px 216.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m113.69 205.36c0.07 0 1.77 4 3.8 9s3.63 9.06 3.56 9.09-1.77-4-3.8-9-3.62-9.06-3.56-9.09z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.37px 214.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m117.5 202.17c0.07 0 2.07 4.37 4.48 9.83s4.31 9.9 4.24 9.93-2.07-4.37-4.48-9.83-4.31-9.9-4.24-9.93z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "121.86px 212.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m119.55 288.56a8.68 8.68 0 1 1-8.68-8.68 8.67 8.67 0 0 1 8.68 8.68z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.87px 288.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m124.22 258a6.49 6.49 0 1 1-6.49-6.49 6.5 6.5 0 0 1 6.49 6.49z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.73px 258px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99,268a4.7,4.7,0,1,1-4.7-4.7A4.7,4.7,0,0,1,99,268Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "94.3px 268px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m124.84 317.2a2.92 2.92 0 1 1 0-4.13 2.91 2.91 0 0 1 0 4.13z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "122.778px 315.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m85.3 294.08a4.69 4.69 0 1 1-4.69-4.69 4.69 4.69 0 0 1 4.69 4.69z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "80.61px 294.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m110.87 288.56c0.3-0.13 3.2 5.45 6.49 12.48s5.71 12.84 5.42 13-3.19-5.45-6.48-12.48-5.72-12.86-5.43-13z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "116.825px 301.301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m110.18 289.44c0 0.32-6.29 1.52-14.15 2.69s-14.27 1.87-14.32 1.52 6.29-1.52 14.15-2.65 14.27-1.88 14.32-1.56z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "95.9449px 291.553px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m109.58 285.27c-0.2 0.23-4.23-3-8.28-8s-6.51-9.53-6.24-9.68 3.14 4.08 7.14 8.93 7.61 8.48 7.38 8.75z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "102.315px 276.434px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M117.73,258h0s0,0,0,0v0l0,.22-.15.84c-.22,1-.44,2-.67,3.06-.59,2.57-1.45,6.12-2.45,10-2,7.81-3.68,14.12-4,14.05s.84-6.52,2.85-14.34c1-3.91,2-7.43,2.79-10,.4-1.26.75-2.28,1-3a6.89,6.89,0,0,1,.36-.78,1,1,0,0,1,.14-.2l0,0s.11,0,.07,0A0,0,0,0,1,117.73,258Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "114.069px 272.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M354.52,159.71l.56,2,2.76-.78,5.09,18-4,27.18a4.28,4.28,0,0,0,5.4,4.75l21.57-6.1a4.29,4.29,0,0,0,2.11-6.89l-18.31-21.68-4.83-17.11,2.65-.75-.6-2.1Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "371.769px 183.626px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M354.52,159.71l.2-.07.6-.18,2.4-.69,9.14-2.63.08,0,0,.08c.18.65.39,1.36.6,2.1l0,.08-.08,0-2.65.76.06-.12c1.37,4.8,3,10.61,4.87,17.11l0,0L382.39,191l3.44,4.08,1.76,2.08a9.38,9.38,0,0,1,.86,1.09,4.42,4.42,0,0,1-1.65,6.23l-.33.16-.35.13c-.23.08-.45.14-.68.2l-1.37.39-2.77.79-14.67,4.14-1.77.5a5.67,5.67,0,0,1-1.83.31,4.42,4.42,0,0,1-4.29-4.91c.16-1.16.34-2.29.5-3.41,1.35-9,2.56-17.07,3.59-23.92v.05c-2.24-8-4-14.21-5-18l.06,0-2.76.77h0v0l-.41-1.51c-.09-.33-.12-.48-.12-.48l.15.49c.1.34.24.83.44,1.49l0,0,2.76-.79,0,0,0,.05c1.08,3.8,2.86,10,5.14,18v.05c-1,6.84-2.2,14.94-3.52,23.92-.16,1.12-.35,2.26-.5,3.4a4.13,4.13,0,0,0,4,4.6,5.31,5.31,0,0,0,1.74-.3l1.77-.5,14.67-4.15,2.77-.78,1.37-.39a6.56,6.56,0,0,0,.67-.21l.33-.11.3-.16a4.1,4.1,0,0,0,1.82-1.95,4.14,4.14,0,0,0,.24-2.64,3.91,3.91,0,0,0-.51-1.23,11.46,11.46,0,0,0-.84-1.06c-.58-.7-1.17-1.39-1.75-2.08l-3.44-4.08-12.61-15,0,0v0l-4.81-17.12,0-.09.09,0,2.65-.74-.06.1c-.2-.74-.4-1.45-.58-2.1l.09.06-9.12,2.53-2.42.67-.62.16Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "371.82px 183.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m361.47 200.08a3.74 3.74 0 0 1 3-3.2 20.72 20.72 0 0 0 3.6-0.74c2-0.76 3.4-2.51 4.95-4s3.62-2.77 5.69-2.28l7.13 7.76a3.29 3.29 0 0 1-1.54 5.38l-19.3 5.47a3.28 3.28 0 0 1-4.14-3.56z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "373.766px 199.173px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M378.9,191.82a9.39,9.39,0,0,0-1.91,1.87c-.51.66-1,1.49-1.69,2.39a7.63,7.63,0,0,1-2.67,2.44,9.19,9.19,0,0,1-3.54.78c-1.11,0-2.1,0-2.94.06h-2a3.85,3.85,0,0,1-.73,0,3.92,3.92,0,0,1,.72-.07l2-.1c.83,0,1.83-.05,2.92-.12a9,9,0,0,0,3.43-.77,7.54,7.54,0,0,0,2.59-2.34c.66-.88,1.21-1.71,1.74-2.36a7.66,7.66,0,0,1,1.44-1.38,3.19,3.19,0,0,1,.46-.29C378.83,191.83,378.89,191.81,378.9,191.82Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "371.16px 195.598px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m413.58 259.84a14.17 14.17 0 1 0-23.91 0.82l-1.82 3.08 10.71 6.26s1.08-1.69 2-3.22a14.17 14.17 0 0 0 13.02-6.94z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "401.365px 254.244px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.72,267.7l.1-.14.31-.41c.27-.36.68-.89,1.22-1.56s1.21-1.48,2-2.37a21.2,21.2,0,0,1,3.11-2.75,13.94,13.94,0,0,1,2.08-1.24,2.59,2.59,0,0,1,1.27-.26,1.46,1.46,0,0,1,1.14.72,1,1,0,0,1-.32,1.31,2,2,0,0,1-1.42.26,3.87,3.87,0,0,1-2.43-1.67,3.92,3.92,0,0,1-.53-3,2.84,2.84,0,0,1,.76-1.45,1.27,1.27,0,0,1,1.61-.2.91.91,0,0,1,.36.79,1.29,1.29,0,0,1-.34.82,2.75,2.75,0,0,1-1.57.7,4.21,4.21,0,0,1-3.34-.84,3.7,3.7,0,0,1-1.32-3.15,2.13,2.13,0,0,1,.78-1.53,1,1,0,0,1,1.57.29,1.46,1.46,0,0,1,.2.84,2.28,2.28,0,0,1-.23.81,4.08,4.08,0,0,1-1,1.29,4.22,4.22,0,0,1-2.93,1,4.27,4.27,0,0,1-2.73-1.14,2.16,2.16,0,0,1-.76-1.22,1.1,1.1,0,0,1,.63-1.22.94.94,0,0,1,.7,0,1.44,1.44,0,0,1,.52.46,2,2,0,0,1,.25,1.28c-.08.84-.21,1.63-.32,2.39-.47,3-1,5.47-1.33,7.15-.18.84-.33,1.49-.44,1.93l-.12.5-.05.17,0-.18c0-.12.06-.28.11-.5.09-.45.23-1.1.4-1.93.34-1.69.82-4.12,1.28-7.16.1-.76.23-1.56.31-2.38a2,2,0,0,0-.24-1.19.85.85,0,0,0-1.58.6,2.07,2.07,0,0,0,.71,1.14,4.17,4.17,0,0,0,2.64,1.09,4.07,4.07,0,0,0,2.81-1,4,4,0,0,0,1-1.23,1.52,1.52,0,0,0,0-1.49.88.88,0,0,0-.59-.44.91.91,0,0,0-.72.2,2,2,0,0,0-.72,1.41,3.49,3.49,0,0,0,1.27,3,4,4,0,0,0,3.19.81,2.54,2.54,0,0,0,1.47-.65,1.11,1.11,0,0,0,.3-.7.71.71,0,0,0-.3-.65,1,1,0,0,0-.72-.16,1.2,1.2,0,0,0-.67.34,2.87,2.87,0,0,0-.71,1.37,3.77,3.77,0,0,0,.5,2.92,3.73,3.73,0,0,0,2.33,1.61,1.91,1.91,0,0,0,1.31-.23.85.85,0,0,0,.27-1.12,1.32,1.32,0,0,0-1-.65,2.42,2.42,0,0,0-1.21.25,12.54,12.54,0,0,0-2.06,1.21,21.07,21.07,0,0,0-3.11,2.72c-.84.88-1.52,1.68-2.06,2.34l-1.24,1.54-.33.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "399.111px 259.584px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.57,271.53l-9.19-5.4a.8.8,0,0,1-.28-1.1h0a.79.79,0,0,1,1.09-.28l9.19,5.4a.8.8,0,0,1,.29,1.09h0A.81.81,0,0,1,396.57,271.53Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "392.382px 268.137px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.22,272.13l-9.19-5.4a.8.8,0,1,0-.81,1.38l1,.59-.15,3.34a1,1,0,0,0,.5.93l3.29,1.93a1,1,0,0,0,1.07,0l2.79-1.77.69.4a.8.8,0,0,0,.81-1.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "391.218px 270.837px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "397.023px 245.599px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.09,240.27a10.4,10.4,0,0,1,3.4-.19,7.37,7.37,0,0,1,2.21.56c.49.22.72.42.69.53-.08.26-1.2,0-2.94.14a11.64,11.64,0,0,0-10.37,7.17c-.71,1.59-.9,2.72-1.17,2.7-.11,0-.21-.3-.25-.84a7.6,7.6,0,0,1,.25-2.26,10.86,10.86,0,0,1,1.38-3.11,11,11,0,0,1,2.93-3",
    fill: "#fff",
    style: {
      transformOrigin: "397.023px 245.599px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.2,
    style: {
      transformOrigin: "407.396px 242.625px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407,243.43c-.77-.47-1.33-1.08-1.17-1.54.08-.22.35-.35.73-.36a2.86,2.86,0,0,1,2.31,1.37.76.76,0,0,1,0,.82",
    fill: "#fff",
    style: {
      transformOrigin: "407.396px 242.625px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M391.63,275s-.19-.23-.52-.57a6.26,6.26,0,0,0-1.44-1.11,6.14,6.14,0,0,0-1.72-.62c-.46-.09-.75-.11-.75-.13a2.13,2.13,0,0,1,.77,0,5.06,5.06,0,0,1,1.78.59,4.92,4.92,0,0,1,1.45,1.18A2.1,2.1,0,0,1,391.63,275Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "389.415px 273.767px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m394.72 273.15s-1.7-0.9-3.75-2.11-3.69-2.21-3.67-2.25 1.71 0.9 3.76 2.1 3.69 2.22 3.66 2.26z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "391.01px 270.969px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M393.51,273.9a5.49,5.49,0,0,1-1-.44c-.58-.29-1.38-.72-2.24-1.21s-1.63-.95-2.18-1.3a5.63,5.63,0,0,1-.87-.6,7.26,7.26,0,0,1,.93.49l2.21,1.26c.84.48,1.59.91,2.21,1.25A7.12,7.12,0,0,1,393.51,273.9Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "390.365px 272.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.83,88.2l.4.68a4.59,4.59,0,0,0,1.92,1.76l.7.35-.67.41a4.57,4.57,0,0,0-1.76,1.91l-.35.71-.41-.68a4.63,4.63,0,0,0-1.91-1.76L82,91.23l.67-.41a4.66,4.66,0,0,0,1.77-1.91Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "84.925px 91.11px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 122.02,
    cy: 93.48,
    r: 17.14,
    fill: "#ebebeb",
    style: {
      transformOrigin: "122.02px 93.48px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m119.8 98.83a2.8 2.8 0 1 1-2.8-2.83 2.8 2.8 0 0 1 2.8 2.83z",
    fill: "#fff",
    style: {
      transformOrigin: "117px 98.8px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 114.2,
    cy: 90.77,
    r: 1.63,
    fill: "#fff",
    style: {
      transformOrigin: "114.2px 90.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M105.39,97.65c.08.3-14.67,14.45-10.87,17.47s19.8-4.72,33.43-15.73S154,75,150.63,71.46s-20.45,6.94-20.45,6.94l2,1.3s10.3-6.61,13.56-4-6,12.58-19.14,22.15S100.87,114.1,98.9,111.48s7.31-11.37,7.31-11.37Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "122.541px 93.2539px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m112.58 81.41c0.14 0.16-1 1.15-2.34 3.13a15.78 15.78 0 0 0-0.35 17.34c1.24 2 2.36 3.06 2.22 3.22s-1.47-0.68-3-2.7a14.5 14.5 0 0 1-2.11-3.9 15.11 15.11 0 0 1 2.48-14.5c1.61-2 3.02-2.71 3.1-2.59z",
    fill: "#fff",
    style: {
      transformOrigin: "109.366px 93.2581px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m89.68 74.07a6 6 0 1 1 5.81 6.1 6 6 0 0 1-5.81-6.1z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "95.6791px 74.173px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.57 71.94a1 1 0 1 1 1 1 1 1 0 0 1-1-1z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "98.57px 71.94px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 100.08,
    cy: 74.22,
    r: 0.56,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "100.08px 74.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98.76,75.94a.21.21,0,1,1,0,.41.21.21,0,0,1-.21-.21A.21.21,0,0,1,98.76,75.94Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "98.7828px 76.145px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "426.03px 426.64px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M418.22,435.77c-5.56-3.22-8.53-10.71-8.76-16.85s2.34-12.53,7.37-16.05a16.86,16.86,0,0,1,18.29-.15,19.07,19.07,0,0,1,8.39,16.53,21.93,21.93,0,0,1-9,16.46",
    fill: "#f90",
    style: {
      transformOrigin: "426.485px 417.934px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.09,436.37A7.26,7.26,0,0,1,427,435c0-1-.06-2.28-.1-3.82-.09-3.23-.21-7.69-.43-12.62s-.48-9.38-.68-12.6c-.1-1.54-.17-2.82-.23-3.82a6.6,6.6,0,0,1,0-1.41,8.25,8.25,0,0,1,.22,1.39c.11.9.25,2.2.39,3.81.3,3.22.62,7.68.84,12.61s.29,9.4.27,12.63c0,1.62,0,2.93-.05,3.83A8,8,0,0,1,427.09,436.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "426.403px 418.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.11,417.53c0,.15-.9.19-2,.1s-1.95-.27-1.94-.42.9-.19,2-.1S411.12,417.39,411.11,417.53Z",
    fill: "#263238",
    style: {
      transformOrigin: "409.14px 417.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411.41,412c-.06.13-.82-.08-1.7-.47s-1.56-.82-1.5-.95.82.08,1.71.47S411.47,411.9,411.41,412Z",
    fill: "#263238",
    style: {
      transformOrigin: "409.81px 411.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m414.24 407.94c-0.07 0.12-0.93-0.28-1.82-1s-1.46-1.51-1.35-1.61 0.81 0.49 1.68 1.21 1.57 1.28 1.49 1.4z",
    fill: "#263238",
    style: {
      transformOrigin: "412.651px 406.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.09,404.09c-.13.06-.54-.59-.92-1.44s-.57-1.59-.44-1.65.54.59.92,1.44S417.22,404,417.09,404.09Z",
    fill: "#263238",
    style: {
      transformOrigin: "416.41px 402.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.56,401.35c-.13.06-.57-.62-.86-1.57s-.32-1.77-.19-1.79.4.72.68,1.63S421.69,401.29,421.56,401.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "421.017px 399.672px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M429,398.27c.13.05.05.63-.19,1.31s-.54,1.18-.67,1.13-.06-.63.18-1.31S428.88,398.22,429,398.27Z",
    fill: "#263238",
    style: {
      transformOrigin: "428.569px 399.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M434.55,400.64c.1.11-.26.6-.79,1.09s-1.05.81-1.15.71.26-.59.79-1.09S434.45,400.54,434.55,400.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "433.58px 401.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M439.42,403.79c.08.12-.35.55-1,1s-1.18.65-1.26.54.36-.56,1-1S439.34,403.67,439.42,403.79Z",
    fill: "#263238",
    style: {
      transformOrigin: "438.29px 404.559px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M442.88,408.48c.05.13-.63.55-1.53.93s-1.67.59-1.72.45.62-.55,1.52-.93S442.82,408.35,442.88,408.48Z",
    fill: "#263238",
    style: {
      transformOrigin: "441.255px 409.172px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M444.24,413.59c0,.14-.68.35-1.55.45s-1.6.08-1.62-.06.68-.34,1.55-.45S444.22,413.45,444.24,413.59Z",
    fill: "#263238",
    style: {
      transformOrigin: "442.655px 413.783px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M445,419.88c-.06.14-.8-.06-1.66-.43s-1.5-.78-1.44-.91.8.06,1.65.43S445,419.75,445,419.88Z",
    fill: "#263238",
    style: {
      transformOrigin: "443.448px 419.212px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m444.32 425.29c0 0.13-1-0.1-2-0.74s-1.55-1.4-1.45-1.5 0.81 0.47 1.74 1.07 1.76 1.03 1.71 1.17z",
    fill: "#263238",
    style: {
      transformOrigin: "442.59px 424.182px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M441.51,430.2c-.09.11-.83-.32-1.54-1.09s-1.1-1.55-1-1.62.67.53,1.36,1.26S441.6,430.09,441.51,430.2Z",
    fill: "#263238",
    style: {
      transformOrigin: "440.237px 428.851px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M414.81,430.78c.06.13-.72.67-1.75,1.2s-1.92.87-2,.74.71-.66,1.74-1.2S414.74,430.65,414.81,430.78Z",
    fill: "#263238",
    style: {
      transformOrigin: "412.934px 431.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M412.37,426.33c.06.13-.57.55-1.4.92s-1.56.58-1.61.45.56-.54,1.39-.92S412.31,426.2,412.37,426.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "410.866px 427.014px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410.58,422.39c0,.15-.76.37-1.73.51s-1.77.13-1.79,0,.75-.37,1.72-.5S410.55,422.25,410.58,422.39Z",
    fill: "#263238",
    style: {
      transformOrigin: "408.82px 422.647px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M416.46,420.22c0,.14-.71.49-1.72.6s-1.81-.06-1.8-.2.8-.21,1.75-.32S416.41,420.08,416.46,420.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "414.7px 420.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.34,415.36c0,.14-.55.44-1.36.52s-1.46-.1-1.44-.24.64-.21,1.39-.28S421.3,415.22,421.34,415.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "419.94px 415.589px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.28,411.47c0,.13-.7,0-1.45-.23s-1.33-.58-1.28-.71.7,0,1.45.22S422.32,411.33,422.28,411.47Z",
    fill: "#263238",
    style: {
      transformOrigin: "420.914px 411px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M424.07,407.53c-.1.1-.55-.19-.87-.75s-.35-1.08-.21-1.12.38.37.66.86S424.17,407.43,424.07,407.53Z",
    fill: "#263238",
    style: {
      transformOrigin: "423.502px 406.603px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m421.91 423.65c0 0.14-0.53 0.4-1.26 0.58a4.93 4.93 0 0 1-1 0.15l-0.1-0.3h0.33s-0.05 0.15-0.2 0.26l-0.11-0.3a4.64 4.64 0 0 1 1-0.35c0.69-0.15 1.3-0.18 1.34-0.04z",
    fill: "#263238",
    style: {
      transformOrigin: "420.73px 423.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.91,430.56c.06.13-.66.54-1.59.9s-1.74.56-1.79.43.66-.54,1.6-.91S422.86,430.42,422.91,430.56Z",
    fill: "#263238",
    style: {
      transformOrigin: "421.221px 431.222px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.39,427.49c.05.14-.43.42-1.06.64s-1.19.28-1.23.14.43-.42,1.06-.64S417.35,427.35,417.39,427.49Z",
    fill: "#263238",
    style: {
      transformOrigin: "416.246px 427.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.82,413.44c0,.13-.87.05-1.83-.29s-1.65-.8-1.59-.93.83.11,1.77.44S417.85,413.29,417.82,413.44Z",
    fill: "#263238",
    style: {
      transformOrigin: "416.109px 412.842px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.17,411.91c.08.12-.39.57-1,1s-1.26.69-1.33.57.38-.57,1-1S431.09,411.79,431.17,411.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "430.006px 412.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431.9,418.84c0,.14-.46.36-1.1.5s-1.17.12-1.2,0,.46-.36,1.09-.49S431.87,418.7,431.9,418.84Z",
    fill: "#263238",
    style: {
      transformOrigin: "430.749px 419.091px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.74,426.64c-.06.13-.77-.07-1.58-.45s-1.42-.79-1.36-.92.77.07,1.58.45S432.8,426.51,432.74,426.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "431.27px 425.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M431,434.23c-.12.09-.58-.29-1-.84s-.74-1.08-.62-1.17.57.28,1,.84S431.07,434.14,431,434.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "430.183px 433.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M430.59,406.8c.09.11-.21.5-.74.76s-1,.27-1,.14.34-.37.81-.61S430.5,406.69,430.59,406.8Z",
    fill: "#263238",
    style: {
      transformOrigin: "429.728px 407.273px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M437.14,413.8c0,.13-.56.46-1.39.58s-1.5,0-1.49-.18.65-.23,1.42-.34S437.09,413.66,437.14,413.8Z",
    fill: "#263238",
    style: {
      transformOrigin: "435.7px 414.078px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M435.83,407.52c.06.12-.54.55-1.39.83s-1.59.27-1.62.13.65-.37,1.46-.63S435.77,407.39,435.83,407.52Z",
    fill: "#263238",
    style: {
      transformOrigin: "434.327px 408.027px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m438.56 423.52a6.32 6.32 0 0 1-4.39-0.8 7.16 7.16 0 0 1 2.22 0.29 6.8 6.8 0 0 1 2.17 0.51z",
    fill: "#263238",
    style: {
      transformOrigin: "436.365px 423.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M436.13,432.64c-.08.11-.84-.34-1.6-1.1s-1.2-1.52-1.08-1.6.72.5,1.45,1.23S436.22,432.52,436.13,432.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "434.785px 431.295px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m425.44 400.1a23.27 23.27 0 0 0-4.57 3.61 22.28 22.28 0 0 0-5.68 12.57 27.77 27.77 0 0 0 0.34 7.7 61.79 61.79 0 0 0 1.44 6.18c0.5 1.74 1 3.13 1.27 4.1a10.48 10.48 0 0 1 0.44 1.51 8.62 8.62 0 0 1-0.63-1.44c-0.37-0.95-0.88-2.33-1.43-4.07a51.63 51.63 0 0 1-1.56-6.2 27.49 27.49 0 0 1-0.39-7.84 21.94 21.94 0 0 1 5.94-12.77 16.2 16.2 0 0 1 3.4-2.66 10.82 10.82 0 0 1 1.05-0.54c0.24-0.12 0.37-0.17 0.38-0.15z",
    fill: "#263238",
    style: {
      transformOrigin: "419.995px 417.933px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.54,436.11a56.52,56.52,0,0,0,2.34-5.59,31.64,31.64,0,0,0,1.4-14.38,27,27,0,0,0-2.22-7.67,18,18,0,0,0-3.78-5.27,13.77,13.77,0,0,0-3.7-2.34c-1-.4-1.54-.5-1.54-.54a1.18,1.18,0,0,1,.43,0,7.46,7.46,0,0,1,1.18.32,12.79,12.79,0,0,1,3.87,2.25,17.78,17.78,0,0,1,4,5.34,26.64,26.64,0,0,1,2.31,7.8,30.68,30.68,0,0,1-1.57,14.58c-.3.9-.67,1.67-1,2.36s-.61,1.26-.86,1.72A9.91,9.91,0,0,1,432.54,436.11Z",
    fill: "#263238",
    style: {
      transformOrigin: "431.073px 418.205px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "412.37 434.88 441.07 434.88 441.25 440.62 412.37 440.62",
    fill: "#263238",
    style: {
      transformOrigin: "426.81px 437.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "414.81 437.75 416.46 455.29 437.44 455.29 439.13 437.94",
    fill: "#263238",
    style: {
      transformOrigin: "426.97px 446.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M441.25,440.69c0,.15-6.46.26-14.44.26s-14.43-.11-14.43-.26,6.46-.26,14.43-.26S441.25,440.55,441.25,440.69Z",
    fill: "#455a64",
    style: {
      transformOrigin: "426.815px 440.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438.33,446a4.09,4.09,0,0,1-.61,1.1,15.87,15.87,0,0,1-2.23,2.63l-.13.13-.13-.14a41.15,41.15,0,0,0-5.63-4.93h.32L427.43,447l-2.95,2.57-.16.14-.17-.14-4.79-4,.28,0-2.48,3a6.67,6.67,0,0,1-1,1.06,6.18,6.18,0,0,1,.8-1.2l2.34-3.13.12-.16.16.13,4.86,3.94h-.32l2.93-2.58,2.51-2.18.15-.14.16.12a36.33,36.33,0,0,1,5.6,5.09h-.26A28.73,28.73,0,0,0,438.33,446Z",
    fill: "#455a64",
    style: {
      transformOrigin: "427.245px 447.085px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "247.185px 118.86px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m103 180.23a2.71 2.71 0 0 1 0-0.45v-1.28c0-1.17 0-2.81-0.06-4.9 0-4.27-0.08-10.35-0.13-17.84l0.13 0.23-21.34-12.18h0.32l-21.17 12.25c-0.16 0.27 0.2-0.36 0.16-0.29v12.59 11.87l-0.17-0.28 21.16 12.29h-0.26l15.51-8.81 4.27-2.39 1.13-0.61a3.34 3.34 0 0 1 0.41-0.2 1.81 1.81 0 0 1-0.34 0.24l-1.07 0.65-4.17 2.49-15.48 9.08-0.13 0.07-0.13-0.07-21.23-12.18-0.17-0.09v-0.19-11.87-6.22-6.37l0.18-0.31 21.2-12.21 0.16-0.1 0.16 0.1 21.16 12.29 0.13 0.08v0.14c0 7.53-0.09 13.66-0.12 18 0 2.07 0 3.69-0.07 4.86v1.25a1.93 1.93 0 0 1-0.04 0.36z",
    fill: "#f90",
    style: {
      transformOrigin: "81.735px 167.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m103 155.76a9.52 9.52 0 0 1-1.6 1.08l-4.49 2.72c-3.8 2.27-9.08 5.36-14.93 8.74h-0.35-0.07l-0.14-0.08-0.42-0.22-1.62-0.93-2.1-1.22-4-2.32-6.7-3.95-4.48-2.72a9.52 9.52 0 0 1-1.6-1.08 11.29 11.29 0 0 1 1.73 0.85l4.6 2.53 6.84 3.84 4 2.28 2.1 1.21 1.08 0.62 0.55 0.31 0.27 0.16 0.14 0.08h0.06-0.33c5.85-3.38 11.16-6.4 15-8.56l4.6-2.53a10.78 10.78 0 0 1 1.86-0.81z",
    fill: "#f90",
    style: {
      transformOrigin: "81.75px 162.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.8,192.16c-.2,0-.35-5.46-.35-12.21s.15-12.21.35-12.21.34,5.47.34,12.21S82,192.16,81.8,192.16Z",
    fill: "#f90",
    style: {
      transformOrigin: "81.795px 179.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M218.77,60.33c-.07.07-1.08-.94-3-2.62-1-.83-2.19-1.83-3.66-2.91a41.74,41.74,0,0,0-5.23-3.28,23.67,23.67,0,0,0-3.27-1.41,10.65,10.65,0,0,0-3.68-.66,4.18,4.18,0,0,0-1.79.43,2.71,2.71,0,0,0-1.22,1.3,4.49,4.49,0,0,0-.37,1.93,9.85,9.85,0,0,0,.27,2.12,20.72,20.72,0,0,0,1.59,4.27,36.77,36.77,0,0,0,2.41,4.17,58,58,0,0,0,14.1,14.54,37.89,37.89,0,0,0,4.1,2.54,21.28,21.28,0,0,0,4.22,1.72,10.49,10.49,0,0,0,2.12.33,4.58,4.58,0,0,0,1.94-.31,2.74,2.74,0,0,0,1.33-1.18,4.14,4.14,0,0,0,.48-1.78,10.71,10.71,0,0,0-.54-3.7,24,24,0,0,0-1.32-3.31,40.48,40.48,0,0,0-3.12-5.32c-1-1.51-2-2.75-2.8-3.76-1.61-2-2.59-3-2.52-3.11s.3.21.8.67,1.2,1.19,2.06,2.16a45.3,45.3,0,0,1,3,3.67,38.44,38.44,0,0,1,3.32,5.34,23.8,23.8,0,0,1,1.43,3.39,11.4,11.4,0,0,1,.65,4,5.21,5.21,0,0,1-.57,2.19,3.7,3.7,0,0,1-1.78,1.62,5.58,5.58,0,0,1-2.37.42,11,11,0,0,1-2.35-.34,21.47,21.47,0,0,1-4.46-1.77,36.74,36.74,0,0,1-4.24-2.59,57.9,57.9,0,0,1-14.39-14.84A36.4,36.4,0,0,1,197.39,60a21.38,21.38,0,0,1-1.63-4.51,10.35,10.35,0,0,1-.27-2.36,5.5,5.5,0,0,1,.48-2.35A3.76,3.76,0,0,1,197.65,49a5.23,5.23,0,0,1,2.21-.51,11.62,11.62,0,0,1,4,.77,24.7,24.7,0,0,1,3.35,1.53,39.66,39.66,0,0,1,5.24,3.48c1.45,1.14,2.64,2.2,3.58,3.09s1.63,1.63,2.09,2.13S218.8,60.3,218.77,60.33Z",
    fill: "#f90",
    style: {
      transformOrigin: "212.78px 66.1425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M205.7,63.59c.09,0-.3,1.36-.83,3.8-.26,1.21-.54,2.71-.77,4.46a37.65,37.65,0,0,0-.33,6,21.69,21.69,0,0,0,.35,3.42,10.06,10.06,0,0,0,1.22,3.4,4.18,4.18,0,0,0,1.22,1.29,2.83,2.83,0,0,0,1.68.46,4.48,4.48,0,0,0,1.83-.52,8.54,8.54,0,0,0,1.71-1.15,19.31,19.31,0,0,0,3-3.24,34.65,34.65,0,0,0,2.49-3.94,51.36,51.36,0,0,0,3.83-9,52.12,52.12,0,0,0,2.1-9.61,35,35,0,0,0,.23-4.65,19.29,19.29,0,0,0-.56-4.37,9.28,9.28,0,0,0-.73-1.93,4.5,4.5,0,0,0-1.2-1.47,2.84,2.84,0,0,0-1.64-.6,4.26,4.26,0,0,0-1.74.35,10.15,10.15,0,0,0-3,2.08,21.6,21.6,0,0,0-2.26,2.59,37.94,37.94,0,0,0-3.17,5.05c-.82,1.57-1.45,2.95-1.94,4.1-1,2.29-1.42,3.6-1.51,3.57a4,4,0,0,1,.21-1c.18-.63.46-1.57.89-2.74a45.08,45.08,0,0,1,1.79-4.22,35.29,35.29,0,0,1,3.08-5.25,22.74,22.74,0,0,1,2.3-2.74,11,11,0,0,1,3.2-2.31,5.08,5.08,0,0,1,2.15-.46,3.88,3.88,0,0,1,2.2.77A5.3,5.3,0,0,1,223,47.43a9.26,9.26,0,0,1,.85,2.15,19.56,19.56,0,0,1,.63,4.61,33.78,33.78,0,0,1-.21,4.8,53.17,53.17,0,0,1-6.05,19.08,36.34,36.34,0,0,1-2.6,4.05,20.56,20.56,0,0,1-3.18,3.4,9.57,9.57,0,0,1-1.93,1.26,5.26,5.26,0,0,1-2.25.59,3.9,3.9,0,0,1-2.24-.63,5.2,5.2,0,0,1-1.49-1.62,10.74,10.74,0,0,1-1.28-3.74,21.08,21.08,0,0,1-.29-3.56,36.18,36.18,0,0,1,.5-6.06c.29-1.77.65-3.27,1-4.48s.64-2.14.86-2.76A4,4,0,0,1,205.7,63.59Z",
    fill: "#f90",
    style: {
      transformOrigin: "213.726px 66.1657px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.17,57.29c0,.09-1.31.45-3.66,1.29-1.17.42-2.59,1-4.2,1.69a38.72,38.72,0,0,0-5.24,2.86,20.87,20.87,0,0,0-2.72,2.1,10,10,0,0,0-2.25,2.82,4.3,4.3,0,0,0-.47,1.72,3,3,0,0,0,.5,1.67,4.32,4.32,0,0,0,1.4,1.28,8.92,8.92,0,0,0,1.88.85,18.87,18.87,0,0,0,4.33.83,34.24,34.24,0,0,0,4.65,0,53.23,53.23,0,0,0,19-4.78,35.39,35.39,0,0,0,4.08-2.25,19.21,19.21,0,0,0,3.42-2.78A8.85,8.85,0,0,0,232.14,63a4.56,4.56,0,0,0,.62-1.79,2.88,2.88,0,0,0-.35-1.71,4.16,4.16,0,0,0-1.22-1.29,9.93,9.93,0,0,0-3.32-1.42,22.23,22.23,0,0,0-3.39-.57,38.54,38.54,0,0,0-6,0c-1.76.13-3.27.32-4.5.51-2.47.37-3.82.68-3.84.59a3.51,3.51,0,0,1,1-.34c.64-.19,1.58-.44,2.81-.69s2.75-.51,4.53-.7a36.07,36.07,0,0,1,6.08-.14,21.94,21.94,0,0,1,3.54.52,10.74,10.74,0,0,1,3.65,1.5A5.11,5.11,0,0,1,233.25,59a3.84,3.84,0,0,1,.5,2.28,5.35,5.35,0,0,1-.73,2.21,10.3,10.3,0,0,1-1.37,1.85,20.21,20.21,0,0,1-3.59,3,34.88,34.88,0,0,1-4.2,2.35,53,53,0,0,1-19.41,4.89,35,35,0,0,1-4.81-.08,20.37,20.37,0,0,1-4.56-.91,10,10,0,0,1-2.09-1A5.37,5.37,0,0,1,191.3,72a3.92,3.92,0,0,1-.64-2.24,5.11,5.11,0,0,1,.59-2.12,10.71,10.71,0,0,1,2.51-3,21,21,0,0,1,2.87-2.13,36.19,36.19,0,0,1,5.43-2.76c1.65-.68,3.11-1.17,4.31-1.53s2.16-.58,2.8-.72A3.57,3.57,0,0,1,210.17,57.29Z",
    fill: "#f90",
    style: {
      transformOrigin: "212.213px 65.5048px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m217 65.18a3.66 3.66 0 1 1-4.43-2.65 3.65 3.65 0 0 1 4.43 2.65z",
    fill: "#f90",
    style: {
      transformOrigin: "213.453px 66.0809px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293,101.79l.09,3.44S311.5,98,322.3,103.87h0a2.37,2.37,0,0,0,1.83,1.27l4.52.52a2.37,2.37,0,0,0,2.34-1.32h0s10.92-4.85,21.92,1.3l4.18,2-7.23-43.72L298,52.69Z",
    fill: "#f90",
    style: {
      transformOrigin: "325.045px 80.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m290.18 96.9v6.18s18.31-10.35 36.14 1.22l-3.89-29.77s-30.73 16.12-32.25 22.37z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "308.25px 89.415px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M287.84,52.13S309.9,36,325.72,59.64l.62,44.66S307,83.71,288.13,98.18Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "307.09px 75.529px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M326.34,104.3s19-11.46,32.15,1.48L355.57,65l-29.83-3.77Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "342.115px 83.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m325.69 59.68s6.8-14.27 20.45-12.54l8.73 1.4 3.71 41.05s-21.4-3-32.27 14.74z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "342.135px 75.6623px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M326.34,104.3a10.35,10.35,0,0,1-.12-1.75c0-1.23-.07-2.83-.12-4.77-.08-4.12-.18-9.63-.29-15.73s-.24-11.61-.32-15.73c-.05-1.93-.09-3.54-.12-4.76a10.75,10.75,0,0,1,0-1.75,9.71,9.71,0,0,1,.2,1.74c.1,1.12.19,2.75.3,4.76.21,4,.38,9.59.49,15.73s.14,11.71.12,15.74c0,1.94,0,3.54-.06,4.77A10.71,10.71,0,0,1,326.34,104.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "325.91px 82.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M350.05,55.18c0,.11-1.39-.2-3.61-.23a21.64,21.64,0,0,0-3.89.3,22.58,22.58,0,0,0-8.82,3.48,23.36,23.36,0,0,0-3.05,2.44c-1.6,1.54-2.39,2.7-2.48,2.63a3.49,3.49,0,0,1,.5-.84,8.13,8.13,0,0,1,.69-.93,13.63,13.63,0,0,1,1-1.15,20.28,20.28,0,0,1,3-2.58A22.44,22.44,0,0,1,337.75,56a23.88,23.88,0,0,1,4.72-1.26,20,20,0,0,1,4-.18,12.4,12.4,0,0,1,1.52.15,7,7,0,0,1,1.14.2A3.31,3.31,0,0,1,350.05,55.18Z",
    fill: "#263238",
    style: {
      transformOrigin: "339.125px 59.1662px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M351.08,59.85c0,.11-1.38-.2-3.61-.23a21.64,21.64,0,0,0-3.89.3,22.58,22.58,0,0,0-8.82,3.48,21.8,21.8,0,0,0-3,2.43c-1.61,1.55-2.4,2.7-2.49,2.64a3.63,3.63,0,0,1,.5-.85,9.12,9.12,0,0,1,.69-.92,12.22,12.22,0,0,1,1-1.15,20.29,20.29,0,0,1,3-2.59,23,23,0,0,1,4.31-2.3,22.58,22.58,0,0,1,4.72-1.26,20.9,20.9,0,0,1,4-.19,14.75,14.75,0,0,1,1.52.15,8.11,8.11,0,0,1,1.14.21A3,3,0,0,1,351.08,59.85Z",
    fill: "#263238",
    style: {
      transformOrigin: "340.175px 63.8288px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M351.24,64.92c0,.11-1.39-.2-3.62-.23a21.71,21.71,0,0,0-3.89.3,24.44,24.44,0,0,0-4.59,1.27,25,25,0,0,0-4.23,2.21,22.41,22.41,0,0,0-3,2.43c-1.61,1.55-2.39,2.71-2.48,2.64a3.22,3.22,0,0,1,.5-.85,7.82,7.82,0,0,1,.69-.92,12.22,12.22,0,0,1,1-1.15,19.68,19.68,0,0,1,3-2.59,23.63,23.63,0,0,1,4.31-2.3,22.74,22.74,0,0,1,4.72-1.26,20,20,0,0,1,4-.18,12.93,12.93,0,0,1,1.53.14,7.68,7.68,0,0,1,1.13.21A3.23,3.23,0,0,1,351.24,64.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "340.335px 68.9012px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320.32,92.67c-.09.07-1-1.24-2.85-2.9a20.24,20.24,0,0,0-18.18-4.65c-2.45.56-3.85,1.28-3.89,1.18a3.55,3.55,0,0,1,1-.54,17.11,17.11,0,0,1,2.83-1,19.45,19.45,0,0,1,18.55,4.74,17.65,17.65,0,0,1,2,2.26A3.91,3.91,0,0,1,320.32,92.67Z",
    fill: "#263238",
    style: {
      transformOrigin: "307.86px 88.3783px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320.1,86.94c-.08.06-1-1.25-2.84-2.91a20.32,20.32,0,0,0-18.19-4.65c-2.44.56-3.85,1.28-3.89,1.19a4,4,0,0,1,1-.55A17.28,17.28,0,0,1,299,79a19.52,19.52,0,0,1,18.55,4.74,17.31,17.31,0,0,1,2,2.26A3.47,3.47,0,0,1,320.1,86.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "307.64px 82.6369px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.89,81.2c-.09.06-1-1.24-2.85-2.91a20.27,20.27,0,0,0-18.18-4.64c-2.44.56-3.85,1.28-3.89,1.18a3.7,3.7,0,0,1,1-.55,17.11,17.11,0,0,1,2.83-1,19.7,19.7,0,0,1,9.9-.06A19.5,19.5,0,0,1,317.31,78a16.29,16.29,0,0,1,2,2.26A3.36,3.36,0,0,1,319.89,81.2Z",
    fill: "#263238",
    style: {
      transformOrigin: "307.43px 76.9098px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.67,75.46c-.08.07-1-1.24-2.84-2.91a20.27,20.27,0,0,0-18.18-4.64c-2.45.56-3.85,1.28-3.9,1.18a4,4,0,0,1,1-.55,16.51,16.51,0,0,1,2.84-1,19.45,19.45,0,0,1,18.55,4.74,16.1,16.1,0,0,1,2,2.26A3.53,3.53,0,0,1,319.67,75.46Z",
    fill: "#263238",
    style: {
      transformOrigin: "307.21px 71.1633px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.46,69.72c-.08.07-1-1.24-2.85-2.9a20.24,20.24,0,0,0-18.18-4.65c-2.44.56-3.85,1.28-3.89,1.18a3.55,3.55,0,0,1,1-.54,17.11,17.11,0,0,1,2.83-1,19.45,19.45,0,0,1,18.55,4.74,16.2,16.2,0,0,1,2,2.26A3.53,3.53,0,0,1,319.46,69.72Z",
    fill: "#263238",
    style: {
      transformOrigin: "307px 65.4283px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.25,64c-.09.06-1-1.25-2.85-2.91a20.31,20.31,0,0,0-18.18-4.65c-2.45.56-3.85,1.28-3.9,1.19a4,4,0,0,1,1-.55,17.63,17.63,0,0,1,2.84-1,19.52,19.52,0,0,1,18.55,4.74,17.65,17.65,0,0,1,2,2.26A4.29,4.29,0,0,1,319.25,64Z",
    fill: "#263238",
    style: {
      transformOrigin: "306.785px 59.7069px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M331.5,78.2l-.16,12.53s8.32-7.14,19.61-7.44l-.69-12.85s-12.79-.94-18.76,7.76",
    fill: "#ebebeb",
    style: {
      transformOrigin: "341.145px 80.5702px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.4,129.74l.35,3.65a4.16,4.16,0,0,1-1.65,3.73L392.49,157a6,6,0,0,0,0,9.67l14.08,10.58a6.39,6.39,0,0,0,9.85-2.95l11.17-31.11a4.15,4.15,0,0,1,3.25-2.7l3.15-.5Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "412.016px 154.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.4,129.74,434,139.89l.13.1-.17,0-2.39.38c-.42.08-.84.12-1.24.23a4.26,4.26,0,0,0-1.16.55,4.08,4.08,0,0,0-1.58,2.08c-.31.88-.63,1.77-1,2.68-1.3,3.66-2.72,7.63-4.24,11.85s-3.11,8.71-4.79,13.38l-.63,1.76c-.1.29-.21.59-.32.88s-.21.6-.34.89a6.34,6.34,0,0,1-1,1.64l-.34.35-.16.18-.19.16-.38.31-.41.26a6.55,6.55,0,0,1-3.77,1,6.65,6.65,0,0,1-3.7-1.39l-11.24-8.45-2.7-2a6.15,6.15,0,0,1-1.09-8.79l.54-.58c.2-.17.4-.34.61-.5l1.23-.92,2.41-1.8,4.62-3.43,8.29-6.16,6.84-5.08,2.81-2.08c.21-.16.43-.31.62-.47a5.29,5.29,0,0,0,.52-.54,4,4,0,0,0,.67-1.2,4.12,4.12,0,0,0,.24-1.21,9.43,9.43,0,0,0-.06-1.09l-.15-1.72c-.08-.87-.11-1.27-.12-1.4,0,.14.06.54.15,1.42.05.46.11,1,.18,1.7a7.54,7.54,0,0,1,.07,1.1,4,4,0,0,1-.23,1.23,4.29,4.29,0,0,1-.68,1.23,4.56,4.56,0,0,1-.53.55c-.2.17-.41.32-.62.48l-2.8,2.1-6.82,5.1-8.28,6.18-4.61,3.44c-.79.6-1.59,1.2-2.41,1.8a13.05,13.05,0,0,0-2.34,2,6,6,0,0,0,1.06,8.49l2.7,2L406.49,177a6.47,6.47,0,0,0,3.58,1.35,6.32,6.32,0,0,0,3.65-1l.39-.25.37-.3.18-.15.17-.17.32-.34a6.37,6.37,0,0,0,1-1.59c.13-.28.24-.58.35-.88l.31-.88c.22-.59.43-1.18.64-1.76,1.67-4.67,3.28-9.15,4.8-13.37l4.26-11.84c.33-.92.65-1.81,1-2.68a4.25,4.25,0,0,1,1.65-2.16,4.18,4.18,0,0,1,1.19-.56,12,12,0,0,1,1.26-.23l2.4-.38,0,.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "412.025px 154.158px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m421.92 155.46a10.83 10.83 0 0 1-4.15-3.26c-1-1.37-1.75-3-2.73-4.37a6.45 6.45 0 0 0-4-3l-16.7 12.87a5.13 5.13 0 0 0 0.05 8.16l12.61 9.49a5.12 5.12 0 0 0 7.84-2.2z",
    fill: "#f90",
    style: {
      transformOrigin: "407.132px 160.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M433.55,140a4.05,4.05,0,0,1-.67-.11,7.33,7.33,0,0,1-.77-.18,9.13,9.13,0,0,1-1-.3c-.38-.13-.78-.27-1.2-.45s-.87-.39-1.34-.62a20.2,20.2,0,0,1-2.84-1.8,20.48,20.48,0,0,1-2.47-2.3c-.34-.39-.66-.76-.93-1.13a11.42,11.42,0,0,1-.74-1.05c-.23-.32-.39-.63-.55-.9s-.28-.51-.37-.7a6.63,6.63,0,0,1-.28-.62,3,3,0,0,1,.35.58c.1.19.23.42.4.68s.34.57.57.88.47.67.76,1,.6.73.94,1.11a19.2,19.2,0,0,0,5.25,4.06c.46.23.89.46,1.32.63s.81.33,1.18.47.7.23,1,.33l.76.21A4.73,4.73,0,0,1,433.55,140Z",
    fill: "#263238",
    style: {
      transformOrigin: "426.97px 134.92px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "403.592px 156.709px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m397.21 165.52s-0.38-0.13-0.75-0.69a4.2 4.2 0 0 1-0.54-2.72 5.35 5.35 0 0 1 0.55-1.87 8.56 8.56 0 0 1 1.26-1.81 34.27 34.27 0 0 1 3.66-3.21c5.29-4.27 9.72-7.54 9.91-7.31s-3.95 3.87-9.24 8.14a44.79 44.79 0 0 0-3.61 3 8 8 0 0 0-1.2 1.55 5.51 5.51 0 0 0-0.59 1.57 4.43 4.43 0 0 0 0.17 2.42c0.22 0.6 0.44 0.87 0.38 0.93z",
    fill: "#fff",
    style: {
      transformOrigin: "403.592px 156.709px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M419.72,157.48a2.21,2.21,0,0,1-.58-.11c-.36-.09-.89-.23-1.54-.45a9,9,0,0,1-2.15-1,6.08,6.08,0,0,1-1.07-.92,7,7,0,0,1-.89-1.24c-.53-.89-.91-1.8-1.34-2.57a7.49,7.49,0,0,0-1.42-1.85,4.11,4.11,0,0,0-1.33-.83c-.35-.12-.56-.14-.55-.16H409a2.77,2.77,0,0,1,.43.09,3.56,3.56,0,0,1,1.4.79,7.1,7.1,0,0,1,1.49,1.86c.44.78.84,1.69,1.35,2.57a7.63,7.63,0,0,0,.86,1.2,6.15,6.15,0,0,0,1,.9,10,10,0,0,0,2.09,1.05c.63.23,1.16.39,1.51.51A4.32,4.32,0,0,1,419.72,157.48Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "414.285px 152.915px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "236.826px 383.912px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "151.09 429.4 150.65 390.37 171.89 390.37 172.63 429.4",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "161.64px 409.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.64,397.31c0,.24-4.42.42-9.87.42s-9.88-.18-9.88-.42,4.42-.42,9.88-.42S170.64,397.08,170.64,397.31Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "160.765px 397.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.64,403.34c0,.23-4.42.42-9.87.42s-9.88-.19-9.88-.42,4.42-.43,9.88-.43S170.64,403.1,170.64,403.34Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "160.765px 403.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.64,409.36c0,.23-4.42.42-9.87.42s-9.88-.19-9.88-.42,4.42-.42,9.88-.42S170.64,409.13,170.64,409.36Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "160.765px 409.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.64,415.39c0,.23-4.42.42-9.87.42s-9.88-.19-9.88-.42,4.42-.43,9.88-.43S170.64,415.15,170.64,415.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "160.765px 415.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.64,421.41c0,.23-4.42.42-9.87.42s-9.88-.19-9.88-.42,4.42-.42,9.88-.42S170.64,421.18,170.64,421.41Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "160.765px 421.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M148.81,389.08H384.29c2.91,12.92,2.5,27.14,0,42.19H149.81V428.4h14.33a6.77,6.77,0,0,0,6.76-6.77V398.28a6.76,6.76,0,0,0-6.76-6.76H148.81Z",
    fill: "#f90",
    style: {
      transformOrigin: "267.566px 410.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M205.19,410.45h3.93a.88.88,0,0,1,.42.11.8.8,0,0,1,.42.74.9.9,0,0,1,0,.25c-.08.33-.16.67-.26,1a11.17,11.17,0,0,1-2.46,4.44,4.65,4.65,0,0,1-3.35,1.74,3.46,3.46,0,0,1-3.15-2,8.85,8.85,0,0,1-1.17-4.73,12.72,12.72,0,0,1,.46-3.37,11.23,11.23,0,0,1,2.34-4.55,4.7,4.7,0,0,1,3.54-1.88,3.48,3.48,0,0,1,1.49.33,4.88,4.88,0,0,1,2.29,2.87.92.92,0,0,1,.09.39,1,1,0,0,1-.11.43.81.81,0,0,1-.73.42,1.26,1.26,0,0,1-.27,0,.84.84,0,0,1-.54-.53l0-.08a4.06,4.06,0,0,0-.47-.93,2.24,2.24,0,0,0-1.88-1.12,2.18,2.18,0,0,0-1.3.48,6.91,6.91,0,0,0-2.15,3.08,11.55,11.55,0,0,0-.93,4.43,8,8,0,0,0,.68,3.48,2.28,2.28,0,0,0,2.05,1.54,2.81,2.81,0,0,0,1.9-1.14,10.52,10.52,0,0,0,2-3.65q-2.72,0-2.82,0c-.62-.1-.93-.42-.94-.95a.82.82,0,0,1,.08-.29A.9.9,0,0,1,205.19,410.45Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "204.766px 410.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M218.56,402.79a2.17,2.17,0,0,1,.1.28q.26.87,2.78,14.59a.78.78,0,0,1,0,.21.85.85,0,0,1-.12.43.78.78,0,0,1-.7.44h-.14a.78.78,0,0,1-.65-.59l-.94-4.84H214.1l-2.33,4.86a.77.77,0,0,1-.07.16.94.94,0,0,1-.73.42.83.83,0,0,1-.46-.14.82.82,0,0,1-.39-.71.74.74,0,0,1,0-.25c.15-.34.39-.87.73-1.6Q216,405,217,403a.92.92,0,0,1,.81-.6A.9.9,0,0,1,218.56,402.79Zm-1.06,3.26-2.61,5.5h3.69Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "215.778px 410.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M231.69,418.74h-7.1a.82.82,0,0,1-.45-.14,1.28,1.28,0,0,1-.4-.89h0q0-.43,2-14.53a2.91,2.91,0,0,1,0-.31.82.82,0,0,1,1.16-.42.78.78,0,0,1,.44.75c-.06.64-.22,2-.48,4-.81,6.2-1.24,9.48-1.27,9.82h6a1.13,1.13,0,0,1,.45.09.79.79,0,0,1,.54.79.84.84,0,0,1,0,.27A1,1,0,0,1,231.69,418.74Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "228.165px 410.544px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M241.4,402.79a2.17,2.17,0,0,1,.1.28q.25.87,2.77,14.59a.52.52,0,0,1,0,.21.84.84,0,0,1-.11.43.78.78,0,0,1-.7.44h-.14a.77.77,0,0,1-.65-.59l-.94-4.84h-4.83l-2.33,4.86a.48.48,0,0,1-.08.16.93.93,0,0,1-.72.42.89.89,0,0,1-.47-.14.83.83,0,0,1-.38-.71.74.74,0,0,1,0-.25l.72-1.6Q238.82,405,239.81,403a.92.92,0,0,1,.81-.6A.9.9,0,0,1,241.4,402.79Zm-1.06,3.26-2.61,5.5h3.69Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "238.595px 410.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M252.7,411.16c.56,1.54,1,2.72,1.29,3.56.73,2,1.1,3.09,1.1,3.2a.76.76,0,0,1-.14.43.81.81,0,0,1-.71.39.78.78,0,0,1-.7-.57c-.06-.16-.1-.27-.14-.36q-.57-1.32-1.89-5l-4,5.49a1,1,0,0,1-.75.45.88.88,0,0,1-.44-.12.77.77,0,0,1-.4-.71,1,1,0,0,1,0-.18,2.1,2.1,0,0,1,.42-.68q2-2.61,4.46-6.22c-.17-.47-.33-.91-.48-1.34q-2.26-6.08-2.27-6.27a.89.89,0,0,1,.11-.43.72.72,0,0,1,.68-.43.88.88,0,0,1,.8.47l2.36,6.39,4.74-6.44a.93.93,0,0,1,.75-.41.87.87,0,0,1,.39.1.79.79,0,0,1,.41.75,1.18,1.18,0,0,1-.08.39Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "252.104px 410.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M270.27,402.42a.92.92,0,0,1,.39.09.85.85,0,0,1,.45.73q-1.74,13.77-1.92,14.87a8.9,8.9,0,0,1-1.52,3.88,5.48,5.48,0,0,1-7,1.71,5,5,0,0,1-2.5-2.2.8.8,0,0,1-.1-.41.79.79,0,0,1,.12-.42.8.8,0,0,1,.73-.42.8.8,0,0,1,.64.35,4.58,4.58,0,0,0,3.63,2.07,3.61,3.61,0,0,0,2.82-1.43,7.83,7.83,0,0,0,1.57-4.47,4.26,4.26,0,0,1-1.05,1.11,4.21,4.21,0,0,1-2.54.84,2.59,2.59,0,0,1-.48,0,3.76,3.76,0,0,1-2.69-1.93,8.76,8.76,0,0,1-1.19-4.73c0-.86,0-1.75.12-2.66q.19-2.16,1-6.12a.68.68,0,0,1,.08-.24.77.77,0,0,1,.76-.58.9.9,0,0,1,.41.11.75.75,0,0,1,.42.68,31.38,31.38,0,0,1-.39,3.24,45.39,45.39,0,0,0-.56,4.94,10,10,0,0,0,.63,3.85c.49,1.16,1.19,1.73,2.11,1.73l.28,0a3.81,3.81,0,0,0,2.12-1.7,10.63,10.63,0,0,0,1.76-3.91l1.07-8.09a1.08,1.08,0,0,1,.11-.36A.77.77,0,0,1,270.27,402.42Z",
    fill: "#fafafa",
    style: {
      transformOrigin: "264.59px 413.367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M376.16,432.07c-.23,0-.42-9.69-.42-21.64s.19-21.64.42-21.64.42,9.68.42,21.64S376.39,432.07,376.16,432.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "376.16px 410.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M183.46,432.07c-.23,0-.42-9.69-.42-21.64s.19-21.64.42-21.64.42,9.68.42,21.64S183.69,432.07,183.46,432.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "183.46px 410.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M380.29,432.07c-.23,0-.42-9.69-.42-21.64s.19-21.64.42-21.64.42,9.68.42,21.64S380.52,432.07,380.29,432.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "380.29px 410.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M179.6,432.07c-.23,0-.42-9.69-.42-21.64s.19-21.64.42-21.64.42,9.68.42,21.64S179.83,432.07,179.6,432.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "179.6px 410.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.06,395.92l0-.08,24.89,20.08.22.18-.27.07-3.31.87-21,5.52h0l0,0c-7.81-3.31-14.4-6.1-19-8.08L295,412.16l-1.43-.62-.36-.16-.12-.06.13,0,.37.14,1.44.59,5.42,2.24,19.08,8h-.08l21-5.55,3.32-.87-.06.25L318.89,396l0,0v-.05",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "318.63px 409.2px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "341.66 412.8 343.02 414.07 344.84 413.68 344.04 415.36 344.98 416.97 343.13 416.74 341.89 418.13 341.54 416.3 339.84 415.54 341.47 414.65",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "342.41px 415.465px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "317.79 420.71 318.71 421.48 319.88 421.15 319.43 422.27 320.1 423.28 318.89 423.2 318.15 424.14 317.85 422.98 316.72 422.56 317.74 421.91",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "318.41px 422.425px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "291.42 409.89 292.89 409.98 293.81 408.82 294.18 410.25 295.57 410.76 294.32 411.55 294.26 413.03 293.12 412.09 291.7 412.49 292.24 411.12",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "293.495px 410.925px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "352.82 396.23 354.3 396.32 355.21 395.16 355.58 396.59 356.97 397.1 355.72 397.9 355.67 399.38 354.52 398.43 353.1 398.84 353.64 397.46",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "354.895px 397.27px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "317.85 395.26 318.8 395.32 319.38 394.58 319.62 395.49 320.5 395.82 319.7 396.32 319.67 397.27 318.94 396.67 318.03 396.93 318.38 396.05",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "319.175px 395.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m354.89 397.27c0 0.09-8.05-0.18-18-0.6s-18-0.85-18-0.94 8.05 0.17 18 0.6 18.01 0.84 18 0.94z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "336.89px 396.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M150.15,431.27c-.15,0-.26-8.85-.26-19.76s.11-19.75.26-19.75.26,8.84.26,19.75S150.29,431.27,150.15,431.27Z",
    fill: "#263238",
    style: {
      transformOrigin: "150.15px 411.515px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "161.39 345.76 161.03 313.89 178.38 313.89 178.97 345.76",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "170px 329.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m177.35 319.56a59.15 59.15 0 0 1-8.06 0.28 59.15 59.15 0 0 1-8.06-0.28 60.23 60.23 0 0 1 8.06-0.27 60.23 60.23 0 0 1 8.06 0.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "169.29px 319.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m177.35 324.48a59.15 59.15 0 0 1-8.06 0.28 59.15 59.15 0 0 1-8.06-0.28 60.23 60.23 0 0 1 8.06-0.27 60.23 60.23 0 0 1 8.06 0.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "169.29px 324.485px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M177.35,329.4a60.23,60.23,0,0,1-8.06.27,60.23,60.23,0,0,1-8.06-.27,60.23,60.23,0,0,1,8.06-.27A60.23,60.23,0,0,1,177.35,329.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "169.29px 329.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m177.35 334.32a60.23 60.23 0 0 1-8.06 0.27 60.23 60.23 0 0 1-8.06-0.27 60.23 60.23 0 0 1 8.06-0.27 60.23 60.23 0 0 1 8.06 0.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "169.29px 334.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m177.35 339.24a60.23 60.23 0 0 1-8.06 0.27 60.23 60.23 0 0 1-8.06-0.27 60.23 60.23 0 0 1 8.06-0.27 60.23 60.23 0 0 1 8.06 0.27z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "169.29px 339.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M159.53,312.84H351.79c2.37,10.55,2,22.16,0,34.44H160.35v-2.34H172a5.52,5.52,0,0,0,5.53-5.52V320.36a5.52,5.52,0,0,0-5.53-5.53H159.53Z",
    fill: "#455a64",
    style: {
      transformOrigin: "256.481px 330.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M206.49,324a1,1,0,0,1,.08.23q.21.72,2.27,11.92a.51.51,0,0,1,0,.17.73.73,0,0,1-.09.35.63.63,0,0,1-.58.35h-.11a.64.64,0,0,1-.53-.48l-.76-4h-4l-1.9,4-.06.13a.77.77,0,0,1-.6.33.68.68,0,0,1-.69-.69.51.51,0,0,1,0-.2c.12-.28.32-.71.59-1.31q4.16-9,5-10.68a.73.73,0,0,1,1.3-.14Zm-.86,2.66-2.14,4.5h3Z",
    fill: "#263238",
    style: {
      transformOrigin: "204.179px 330.332px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.12,334.66a1,1,0,0,1,0-.31.72.72,0,0,1,.06-.29.52.52,0,0,1,.51-.34.9.9,0,0,1,.63.38l.18.23a3.22,3.22,0,0,0,2.32,1.48,2.63,2.63,0,0,0,2.63-2.63,2.62,2.62,0,0,0-.49-1.57,4.36,4.36,0,0,0-1.35-1.09l-1.23-.73a4.8,4.8,0,0,1-.74-.64,2.86,2.86,0,0,1-.78-2c0-.11,0-.21,0-.33a3.36,3.36,0,0,1,1.08-2.21,3.29,3.29,0,0,1,2.31-.9,3.49,3.49,0,0,1,1.11.18,3.24,3.24,0,0,1,1.75,1.34,1.11,1.11,0,0,1,.1.38.61.61,0,0,1-.09.31.59.59,0,0,1-.54.32.53.53,0,0,1-.44-.17,2.56,2.56,0,0,0-1.9-1.07,2,2,0,0,0-1.42.58,2.08,2.08,0,0,0-.68,1.58,1.63,1.63,0,0,0,.35,1,5,5,0,0,0,1.26,1,12.2,12.2,0,0,1,1.53,1,3.79,3.79,0,0,1,1.62,3,4,4,0,0,1-.08.77,3.88,3.88,0,0,1-1.43,2.28,4.06,4.06,0,0,1-2.59.93,3.61,3.61,0,0,1-1.79-.48A4.62,4.62,0,0,1,210.12,334.66Z",
    fill: "#263238",
    style: {
      transformOrigin: "214.159px 330.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M230,324.39a.56.56,0,0,1-.1.33.73.73,0,0,1-.65.31h-3.94Q224,336,223.87,336.35v.1a.68.68,0,0,1-.71.6.55.55,0,0,1-.36-.11.81.81,0,0,1-.33-.72c0-.07.34-2.69,1-7.87.23-1.75.38-2.86.44-3.32h-3.68a1.16,1.16,0,0,1-.38-.06.57.57,0,0,1-.46-.56.75.75,0,0,1,.1-.38.73.73,0,0,1,.65-.34h9.12a.65.65,0,0,1,.26.06A.64.64,0,0,1,230,324.39Z",
    fill: "#263238",
    style: {
      transformOrigin: "224.695px 330.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M231.33,336.35c-.08.46-.32.7-.71.7a.6.6,0,0,1-.35-.1.81.81,0,0,1-.35-.73q.39-3.24,1.56-11.88a.57.57,0,0,1,.19-.32,1,1,0,0,1,.71-.26,8.85,8.85,0,0,1,1.69-.15,7.55,7.55,0,0,1,1.21.09,2.55,2.55,0,0,1,2.42,2.68,4.62,4.62,0,0,1-.28,1.63q-.87,2.34-4.29,3.4l4.76,4.35a1,1,0,0,1,.3.62.78.78,0,0,1-.1.35.64.64,0,0,1-.56.32,1,1,0,0,1-.56-.19q-.19-.14-5.1-4.64C231.59,334.5,231.4,335.88,231.33,336.35ZM232.82,325l-.66,5.17a6.69,6.69,0,0,0,2.31-.8,3.34,3.34,0,0,0,1.89-3c0-1-.76-1.5-2.26-1.51C234,324.9,233.56,324.94,232.82,325Z",
    fill: "#263238",
    style: {
      transformOrigin: "234.054px 330.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M239.12,331.59a10.36,10.36,0,0,1,.4-2.84,9.24,9.24,0,0,1,1.93-3.67,3.86,3.86,0,0,1,2.84-1.5,2.94,2.94,0,0,1,2.37,1.29,6.57,6.57,0,0,1,1.18,3.61,8.57,8.57,0,0,0,.83-.37,2.7,2.7,0,0,1,1.06-.34.55.55,0,0,1,.31.08.6.6,0,0,1,.32.55.89.89,0,0,1-.3.63,4.4,4.4,0,0,1-2.25.92,9.9,9.9,0,0,1-.33,1.87,8.68,8.68,0,0,1-1.93,3.75,3.89,3.89,0,0,1-2.89,1.48,2.48,2.48,0,0,1-.38,0,3.11,3.11,0,0,1-2.2-1.58A7.2,7.2,0,0,1,239.12,331.59Zm1.46-.25a7.55,7.55,0,0,0,.45,2.73c.4,1,1,1.56,1.78,1.56a1.44,1.44,0,0,0,.61-.15,4.17,4.17,0,0,0,1.77-1.9,9.12,9.12,0,0,0,1.17-3.5,4.25,4.25,0,0,1-2.34-.72,5.11,5.11,0,0,1-2-2.77A8.64,8.64,0,0,0,240.58,331.34Zm4-6.19a.92.92,0,0,0-.41.1,1.14,1.14,0,0,0-.47,1.08,1.53,1.53,0,0,0,0,.3,2.35,2.35,0,0,0,1.19,1.61,3,3,0,0,0,1.51.5,9.94,9.94,0,0,0-.21-1.41C245.88,325.93,245.34,325.21,244.56,325.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "244.737px 330.319px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M258.66,336.38c-.06.44-.29.67-.68.67a.85.85,0,0,1-.73-.5l-4.37-10c0,.47-.12,1-.2,1.58q-.85,7.18-1,8.19c-.08.46-.31.7-.71.7a.64.64,0,0,1-.37-.11.82.82,0,0,1-.34-.72c1.05-7.9,1.57-11.85,1.57-11.88a.79.79,0,0,1,.1-.27.7.7,0,0,1,.64-.36.71.71,0,0,1,.72.34l4.35,9.75,1.26-9.42a1.09,1.09,0,0,1,.08-.31.6.6,0,0,1,.58-.38.7.7,0,0,1,.34.1.65.65,0,0,1,.33.59c0,.2-.05.41-.08.63Q258.86,335.23,258.66,336.38Z",
    fill: "#263238",
    style: {
      transformOrigin: "255.244px 330.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M261.69,331.59a10.36,10.36,0,0,1,.4-2.84,9.13,9.13,0,0,1,1.94-3.67,3.82,3.82,0,0,1,2.83-1.5,2.94,2.94,0,0,1,2.37,1.29,6.49,6.49,0,0,1,1.18,3.61,8.57,8.57,0,0,0,.83-.37,2.7,2.7,0,0,1,1.06-.34.55.55,0,0,1,.31.08.6.6,0,0,1,.32.55.89.89,0,0,1-.3.63,4.4,4.4,0,0,1-2.25.92,9.9,9.9,0,0,1-.33,1.87,8.68,8.68,0,0,1-1.93,3.75,3.89,3.89,0,0,1-2.89,1.48,2.48,2.48,0,0,1-.38,0,3.11,3.11,0,0,1-2.2-1.58A7.2,7.2,0,0,1,261.69,331.59Zm1.46-.25a7.55,7.55,0,0,0,.45,2.73c.4,1,1,1.56,1.78,1.56a1.44,1.44,0,0,0,.61-.15,4.17,4.17,0,0,0,1.77-1.9,9.12,9.12,0,0,0,1.17-3.5,4.19,4.19,0,0,1-2.33-.72,5.07,5.07,0,0,1-2-2.77A8.64,8.64,0,0,0,263.15,331.34Zm4-6.19a1,1,0,0,0-.41.1,1.14,1.14,0,0,0-.47,1.08,1.53,1.53,0,0,0,0,.3,2.35,2.35,0,0,0,1.19,1.61,3.07,3.07,0,0,0,1.51.5,9.94,9.94,0,0,0-.21-1.41C268.45,325.93,267.91,325.21,267.13,325.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "267.307px 330.319px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M282.43,336.35v0c-.06.45-.29.67-.68.67a.61.61,0,0,1-.36-.1.81.81,0,0,1-.35-.73c0-.1.28-2.46.82-7.08-1.37,2.88-2.44,5.16-3.22,6.82-.17.36-.26.56-.29.6a.78.78,0,0,1-.68.49h-.16a.8.8,0,0,1-.55-.6l-1.5-7.32q-.51,3.94-1,7.23v0c-.06.45-.29.67-.69.67a.65.65,0,0,1-.36-.1.82.82,0,0,1-.34-.73q0-.09,1.23-9.31c.21-1.59.32-2.44.34-2.57a.85.85,0,0,1,.1-.28.72.72,0,0,1,.63-.35l.2,0a.53.53,0,0,1,.42.39q.17,1,1.11,5.62l.87,4.35,4.67-9.89.09-.18a.77.77,0,0,1,.62-.32.56.56,0,0,1,.31.09.7.7,0,0,1,.38.59c0,.16,0,.35-.07.57Q282.65,335.09,282.43,336.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "278.554px 330.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294.71,323.73a.72.72,0,0,1,.32.08.68.68,0,0,1,.37.59q-1.42,11.24-1.57,12.15a7.41,7.41,0,0,1-1.24,3.16,4.47,4.47,0,0,1-5.7,1.4,4.14,4.14,0,0,1-2.05-1.8.77.77,0,0,1,0-.68.66.66,0,0,1,1.12-.06,3.72,3.72,0,0,0,3,1.69,2.89,2.89,0,0,0,2.3-1.17,6.36,6.36,0,0,0,1.28-3.64,3.67,3.67,0,0,1-.85.91,3.5,3.5,0,0,1-2.08.68l-.39,0a3.09,3.09,0,0,1-2.2-1.58,7.18,7.18,0,0,1-1-3.86c0-.7,0-1.43.1-2.17.11-1.18.37-2.84.78-5a.76.76,0,0,1,.06-.2.64.64,0,0,1,.62-.47.69.69,0,0,1,.34.09.63.63,0,0,1,.35.56A26.46,26.46,0,0,1,288,327a35.24,35.24,0,0,0-.46,4,8,8,0,0,0,.52,3.14c.39.94,1,1.41,1.71,1.41a1,1,0,0,0,.24,0,3.19,3.19,0,0,0,1.73-1.39,8.5,8.5,0,0,0,1.43-3.19l.88-6.61a.75.75,0,0,1,.09-.29A.62.62,0,0,1,294.71,323.73Z",
    fill: "#263238",
    style: {
      transformOrigin: "290.08px 332.668px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 321.69,
    cy: 330.2,
    r: 10.11,
    fill: "#263238",
    style: {
      transformOrigin: "321.69px 330.2px",
      transform: "rotate(-37.11deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m320.38 333.35a1.65 1.65 0 1 1-1.65-1.65 1.65 1.65 0 0 1 1.65 1.65z",
    fill: "#455a64",
    style: {
      transformOrigin: "318.73px 333.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318 328.6a1 1 0 1 1-1-1 1 1 0 0 1 1 1z",
    fill: "#455a64",
    style: {
      transformOrigin: "317px 328.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M311.88,332.66c.05.17-8.65,8.52-6.41,10.3s11.68-2.79,19.72-9.28,15.38-14.38,13.37-16.47-12.06,4.09-12.06,4.09l1.2.77s6.08-3.9,8-2.38-3.56,7.42-11.29,13.06-15.2,9.61-16.36,8.06,4.31-6.7,4.31-6.7Z",
    fill: "#263238",
    style: {
      transformOrigin: "321.999px 330.063px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "314.228px 330.067px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M316.12,323.08c.08.09-.6.68-1.38,1.84a9.32,9.32,0,0,0-.2,10.23c.73,1.19,1.39,1.8,1.3,1.9s-.86-.4-1.76-1.59a8.68,8.68,0,0,1-1.23-2.3,9.09,9.09,0,0,1-.52-3.17,9,9,0,0,1,2-5.39C315.24,323.44,316.07,323,316.12,323.08Z",
    fill: "#455a64",
    style: {
      transformOrigin: "314.228px 330.067px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M345.15,347.94c-.15,0-.27-7.91-.27-17.67s.12-17.67.27-17.67.27,7.91.27,17.67S345.3,347.94,345.15,347.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "345.15px 330.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M187.82,347.94c-.15,0-.27-7.91-.27-17.67s.12-17.67.27-17.67.27,7.91.27,17.67S188,347.94,187.82,347.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "187.82px 330.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M348.52,347.94c-.15,0-.27-7.91-.27-17.67s.12-17.67.27-17.67.28,7.91.28,17.67S348.67,347.94,348.52,347.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "348.525px 330.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M184.67,347.94c-.15,0-.28-7.91-.28-17.67s.13-17.67.28-17.67.27,7.91.27,17.67S184.82,347.94,184.67,347.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "184.665px 330.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m390.33 350.77v36h-69.69v-36z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "355.485px 368.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m165.26 369.11v1a20.64 20.64 0 0 0 20.74 19.28h207.58v-2.6h-49.27a18 18 0 0 1-18-18 18 18 0 0 1 18-18h49.27v-3.79l-207.61 0.7a20.76 20.76 0 0 0-20.71 21.41z",
    fill: "#f90",
    style: {
      transformOrigin: "279.415px 368.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m390.33 369.26c0 0.2-14.33 0.37-32 0.37s-32-0.17-32-0.37 14.32-0.37 32-0.37 32 0.17 32 0.37z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "358.33px 369.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.32,377.38c0,.2-13.56.36-30.28.36s-30.28-.16-30.28-.36S342.32,377,359,377,389.32,377.17,389.32,377.38Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "359.04px 377.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.33,384.8c0,.2-12.19.37-27.22.37s-27.23-.17-27.23-.37,12.19-.37,27.23-.37S390.33,384.59,390.33,384.8Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "363.105px 384.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M390.33,362c0,.2-14,.37-31.34.37s-31.35-.17-31.35-.37,14-.37,31.35-.37S390.33,361.76,390.33,362Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "358.985px 362px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M389.32,354.68c0,.2-12.49.37-27.9.37s-27.9-.17-27.9-.37,12.49-.37,27.9-.37S389.32,354.47,389.32,354.68Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "361.42px 354.68px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "279.415px 368.195px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m165.26 369.11v1a20.64 20.64 0 0 0 20.74 19.28h207.58v-2.6h-49.27a18 18 0 0 1-18-18 18 18 0 0 1 18-18h49.27v-3.79l-207.61 0.7a20.76 20.76 0 0 0-20.71 21.41z",
    style: {
      transformOrigin: "279.415px 368.195px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m190.41 348.25a46.15 46.15 0 0 0-4.42 5.24 26.65 26.65 0 0 0 0.37 30.87 44.46 44.46 0 0 0 4.53 5.13 7.15 7.15 0 0 1-1.49-1.1 23.83 23.83 0 0 1-3.46-3.72 26.26 26.26 0 0 1-0.38-31.48 24.34 24.34 0 0 1 3.38-3.8 7.77 7.77 0 0 1 1.47-1.14z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "185.699px 368.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m183.39 347.48a46.15 46.15 0 0 0-4.42 5.24 26.65 26.65 0 0 0 0.37 30.87 45.74 45.74 0 0 0 4.54 5.14 7.9 7.9 0 0 1-1.5-1.11 23.85 23.85 0 0 1-3.46-3.72 26.28 26.28 0 0 1-0.37-31.48 23.87 23.87 0 0 1 3.37-3.8 7.77 7.77 0 0 1 1.47-1.14z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "178.689px 368.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m324.41 348.25a46.86 46.86 0 0 0-4.41 5.24 26.67 26.67 0 0 0 0.36 30.87 43.84 43.84 0 0 0 4.54 5.13 7 7 0 0 1-1.5-1.1 24.83 24.83 0 0 1-3.46-3.72 26.28 26.28 0 0 1-0.37-31.48 24.9 24.9 0 0 1 3.37-3.8 8.17 8.17 0 0 1 1.47-1.14z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "319.709px 368.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m317.39 347.48a46.86 46.86 0 0 0-4.41 5.24 26.67 26.67 0 0 0 0.36 30.87 45.74 45.74 0 0 0 4.54 5.14 8.08 8.08 0 0 1-1.49-1.11 23.82 23.82 0 0 1-3.47-3.72 26.28 26.28 0 0 1-0.37-31.48 24.34 24.34 0 0 1 3.38-3.8 8 8 0 0 1 1.46-1.14z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "312.689px 368.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M214,374.18q-.1-7.33-.2-14.65a10.43,10.43,0,0,0-.52-3.77,3.53,3.53,0,0,0-2.78-2.35c-1.83-.81-4.69.72-6,2.83s-1.42,4.71-1.44,7.18a104,104,0,0,0,.56,11.57,13.33,13.33,0,0,0,1.37,5.29,4.91,4.91,0,0,0,4.46,2.69,5,5,0,0,0,3.92-3.4A14.77,14.77,0,0,0,214,374.18Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "208.546px 368.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294.63,370c0,.21-15,.37-33.51.37s-33.51-.16-33.51-.37,15-.37,33.51-.37S294.63,369.76,294.63,370Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "261.12px 370px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m374.77 455.09h-291.47c-3.82-8.47-4.76-16.51 0-23.71h291.47c3.83 8.62 3.5 16.47 0 23.71z",
    fill: "#455a64",
    style: {
      transformOrigin: "228.797px 443.235px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 143.65,
    y: 438.15,
    width: 157.91,
    height: 8.63,
    fill: "#ebebeb",
    style: {
      transformOrigin: "222.605px 442.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m94.49 455.22c-0.09 0.07-1.13-0.91-2.3-2.88a20.56 20.56 0 0 1-1.54-17.14 8.53 8.53 0 0 1 1.74-3.2c0.16 0.07-0.45 1.32-1 3.43a23.64 23.64 0 0 0-0.79 8.43 23.9 23.9 0 0 0 2.24 8.14c0.96 2 1.78 3.11 1.65 3.22z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "91.9808px 443.612px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m100.79 455.22a8.63 8.63 0 0 1-2.29-2.88 20.47 20.47 0 0 1-1.5-17.14 8.53 8.53 0 0 1 1.7-3.2c0.15 0.07-0.45 1.32-1 3.43a23.38 23.38 0 0 0 1.5 16.6c0.91 1.97 1.73 3.08 1.59 3.19z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "98.2947px 443.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m363 454.66c-0.31-0.11 2.07-5 2.07-11.59s-2.25-11.51-1.93-11.62 3 4.81 3 11.63-2.98 11.75-3.14 11.58z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "364.556px 443.056px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M357.56,454.6c-.31-.06.92-5.07.89-11.35s-1.23-11.28-.92-11.35,2,4.91,2,11.35S357.79,454.69,357.56,454.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "358.504px 443.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "280.959px 245.382px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m345.48 309.71-22.09-17.09 13.91-20 22.89 20s-0.08 8.36-3.27 11.85-11.44 5.24-11.44 5.24z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "341.79px 291.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M231.84,258c.07-.64,33.07-28.72,36.72-31,4.57-2.82,15.76-4.09,21.55.9,5.37,4.64,51.68,43.33,51.68,43.33l-18.68,22.79-40.24-31.42s-38.18,23-38.56,23.54S226,280,226,279.4,231.84,258,231.84,258Z",
    fill: "#263238",
    style: {
      transformOrigin: "283.895px 259.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M336.83,303l19.47,16.6,4.28,8c1.63,3.06,3.8,1.16,6.85-.47l37.25-19.84s-.24-4.67-3.61-4.38-30.32-.1-30.32-.1L353.8,286.41Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "370.755px 307.819px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M334,303l5.08,3.85a1.92,1.92,0,0,0,2.55-.22l15.07-16.21a1.9,1.9,0,0,0,0-2.55l-4.09-4.67a1.9,1.9,0,0,0-2.81-.05l-16.08,17A1.89,1.89,0,0,0,334,303Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "345.195px 294.894px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M357.28,289.78a20.25,20.25,0,0,1-2,2.78c-1.32,1.66-3.19,3.92-5.39,6.29s-4.31,4.41-5.89,5.82c-.8.7-1.45,1.26-1.92,1.63a3,3,0,0,1-.75.53,26.86,26.86,0,0,1,2.41-2.43c1.52-1.47,3.58-3.54,5.77-5.9s4.1-4.58,5.48-6.18A26,26,0,0,1,357.28,289.78Z",
    fill: "#263238",
    style: {
      transformOrigin: "349.305px 298.305px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m343.26 304.17a9.6 9.6 0 0 1-6.72-7 21.89 21.89 0 0 0 2.79 4.05 22.6 22.6 0 0 0 3.93 2.95z",
    fill: "#263238",
    style: {
      transformOrigin: "339.9px 300.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m349.55 298.92a35.14 35.14 0 0 1-7.92-7.15 38.24 38.24 0 0 1 4 3.49 37.26 37.26 0 0 1 3.92 3.66z",
    fill: "#263238",
    style: {
      transformOrigin: "345.59px 295.345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m354.92 291.81a17.81 17.81 0 0 0-3.65-3.5 17 17 0 0 0-4.71-1.83 3.14 3.14 0 0 1 1.54 0 9.88 9.88 0 0 1 3.45 1.36 9.53 9.53 0 0 1 2.69 2.57 3.5 3.5 0 0 1 0.68 1.4z",
    fill: "#263238",
    style: {
      transformOrigin: "350.74px 289.097px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M370,325.53c-.07.05-.53-.63-1.46-1.52a11.43,11.43,0,0,0-9.19-3.13c-1.28.14-2.06.39-2.08.31a5,5,0,0,1,2-.67,10.49,10.49,0,0,1,5.16.41,10.61,10.61,0,0,1,4.34,2.82A4.88,4.88,0,0,1,370,325.53Z",
    fill: "#263238",
    style: {
      transformOrigin: "363.635px 322.951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m393.68 313.2s-0.52-0.35-1.07-1.18a6.78 6.78 0 0 1-1.1-3.69 9.49 9.49 0 0 1 0.85-3.76 3.92 3.92 0 0 1 0.81-1.36 6.44 6.44 0 0 1-0.47 1.5 11.74 11.74 0 0 0-0.67 3.62 7.56 7.56 0 0 0 0.9 3.51c0.44 0.83 0.82 1.3 0.75 1.36z",
    fill: "#263238",
    style: {
      transformOrigin: "392.599px 308.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m249.68 190.61c-0.41-3.3-4-5.4-4.81-8.62-1-3.72 2-7.28 2.48-11.09 0.48-3.66-1.33-7.18-2.29-10.75-2-7.27-0.45-15 0.25-22.45s1.05-21.35-11.13-29.48l-10.36-4.64c-8.75 17.66-5.12 46-8.83 65.31-1.34 7-2.34 14.3-0.81 21.29a52.52 52.52 0 0 0 5.23 13c2.3 4.38 5 8.87 9.26 11.31s10.68 1.86 13.11-2.44c1.82-3.22 0.95-7.36 2.4-10.76 1.61-3.75 6.01-6.61 5.5-10.68z",
    fill: "#263238",
    style: {
      transformOrigin: "231.565px 159.753px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M192.68,169.08s-7.71.89-13,4.61c-8.33,5.89-14.1,19.08-17,37.91-2.41,15.67-3.85,32.83-4.59,44.32-1.1,17.42-1.17,25.28,0,29.13,2,6.39,5.45,28.31,19.89,30.53,0,0,5-6.94,6.94-14.16s8.58-27.28,27.15-29.75c1.66-.22,20.35-3,20.35-3s-1.26-18-1.26-25c0-3.54,1.18-10.21,2.35-16,1.5-7.39-.6-15.24-2.6-22.51S227.39,188,226,185.42a18.92,18.92,0,0,0-7.64-7.19Z",
    fill: "#f90",
    style: {
      transformOrigin: "195.629px 242.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M207,272.23s-.65,0-1.81,0a25.58,25.58,0,0,0-4.89.55,33.34,33.34,0,0,0-6.93,2.23,30.91,30.91,0,0,0-7.55,4.66c-4.76,4.21-7.94,9.12-10.22,12.59l-2.64,4.19a12.48,12.48,0,0,1-1,1.51,11.25,11.25,0,0,1,.83-1.63c.56-1,1.4-2.49,2.48-4.29a55.3,55.3,0,0,1,10.19-12.81,30.23,30.23,0,0,1,7.72-4.71,31.54,31.54,0,0,1,7.07-2.14,22.53,22.53,0,0,1,5-.38,11,11,0,0,1,1.35.12A1.4,1.4,0,0,1,207,272.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "189.48px 284.973px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "181.359px 284.771px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m170.78 289.91a5.71 5.71 0 0 0-1.34 2.41 2.16 2.16 0 0 0 1 2.37c1.17 0.52 2.43-0.48 3.3-1.43 3.17-3.47 5.92-7.31 9.07-10.8s6.15-6 10.53-7.75c-10.86 3.29-15.4 6.35-22.56 15.2z",
    style: {
      transformOrigin: "181.359px 284.771px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "197.976px 239.508px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m230.05 249.87a2 2 0 0 0-0.81-1.47 2.37 2.37 0 0 0-2 0.14l-24.5 9.46c-4.81 1.85-10.06 3.72-15 2.25-5.17-1.53-8.72-6.54-10-11.78s-0.56-10.74 0.33-16 2.41-13.85 2.41-13.85l-11.37-17.09c-1.7 16.12-6.8 50.56-3.73 63.92 1.18 5.09 4 8.29 8.38 11.13 3.6 2.33 10.4-0.37 14.87-2.14 11.59-4.62 22.63-9.25 31.76-14.5 2.23-1.29 9.08-5.93 10.59-8s-0.49 0.47-0.93-2.07z",
    style: {
      transformOrigin: "197.976px 239.508px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M178.74,314.47c-.22.33,20.66,3.3,38.47,2.43S272.64,302,272.64,302a119.25,119.25,0,0,0-1.57,16.34c-.06,7.49,3.62,32.78,3.62,32.78H305.6V296.92s-.87-20.48-.93-23.85c-.1-5.09-6.15-12.38-16-11.81-8.34.49-82.23,11.05-82.23,11.05s-11.13,3.52-15.63,9.46S178.74,314.47,178.74,314.47Z",
    fill: "#263238",
    style: {
      transformOrigin: "242.169px 306.174px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M190,296.45a13.52,13.52,0,0,1-5.57-.18,13.53,13.53,0,0,1,5.57.18Z",
    fill: "#455a64",
    style: {
      transformOrigin: "187.215px 296.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M201.16,295.9a6.82,6.82,0,0,1-2.76.5,7.1,7.1,0,0,1-2.81-.08,6.92,6.92,0,0,1,2.76-.5A7.35,7.35,0,0,1,201.16,295.9Z",
    fill: "#455a64",
    style: {
      transformOrigin: "198.375px 296.112px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M212.21,294.43a6.83,6.83,0,0,1-2.71.7,6.91,6.91,0,0,1-2.8.13,13.6,13.6,0,0,1,5.51-.83Z",
    fill: "#455a64",
    style: {
      transformOrigin: "209.455px 294.877px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m223.18 292.35a7 7 0 0 1-2.68 0.84 6.9 6.9 0 0 1-2.79 0.26 6.82 6.82 0 0 1 2.67-0.83 7.06 7.06 0 0 1 2.8-0.27z",
    fill: "#455a64",
    style: {
      transformOrigin: "220.445px 292.902px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.07 290a13.71 13.71 0 0 1-5.44 1.22 6.8 6.8 0 0 1 2.66-0.9 6.92 6.92 0 0 1 2.78-0.32z",
    fill: "#455a64",
    style: {
      transformOrigin: "231.35px 290.596px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M245,287.51a7.27,7.27,0,0,1-2.66.89,7,7,0,0,1-2.79.32,7.27,7.27,0,0,1,2.66-.89A7,7,0,0,1,245,287.51Z",
    fill: "#455a64",
    style: {
      transformOrigin: "242.275px 288.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M255.89,285.26a6.9,6.9,0,0,1-2.68.83,7,7,0,0,1-2.8.25,7,7,0,0,1,2.69-.82A6.9,6.9,0,0,1,255.89,285.26Z",
    fill: "#455a64",
    style: {
      transformOrigin: "253.15px 285.801px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266.91,283.51a7.25,7.25,0,0,1-2.72.68,7,7,0,0,1-2.81.11,7,7,0,0,1,2.72-.68A7,7,0,0,1,266.91,283.51Z",
    fill: "#455a64",
    style: {
      transformOrigin: "264.145px 283.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M278,282.82a10.69,10.69,0,0,1-2.77.19,7.84,7.84,0,0,1-2.8-.1,6.31,6.31,0,0,1,2.78-.48A5.13,5.13,0,0,1,278,282.82Z",
    fill: "#455a64",
    style: {
      transformOrigin: "275.215px 282.736px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M284.42,290.47c-.18,0-.29-1.25-.62-2.7s-1-2.48-.88-2.58,1.1.85,1.44,2.44A4.89,4.89,0,0,1,284.42,290.47Z",
    fill: "#455a64",
    style: {
      transformOrigin: "283.754px 287.826px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m284.86 301.62a7.06 7.06 0 0 1-0.41-2.78 6.79 6.79 0 0 1 0.18-2.8 7 7 0 0 1 0.4 2.78 6.89 6.89 0 0 1-0.17 2.8z",
    fill: "#455a64",
    style: {
      transformOrigin: "284.741px 298.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m285.41 312.76a7 7 0 0 1-0.41-2.76 6.7 6.7 0 0 1 0.15-2.8 7 7 0 0 1 0.43 2.77 6.9 6.9 0 0 1-0.17 2.79z",
    fill: "#455a64",
    style: {
      transformOrigin: "285.284px 309.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M286,323.9a13.77,13.77,0,0,1-.31-5.57,13.32,13.32,0,0,1,.31,5.57Z",
    fill: "#455a64",
    style: {
      transformOrigin: "285.85px 321.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M286.61,335a13.31,13.31,0,0,1-.29-5.57,13.77,13.77,0,0,1,.29,5.57Z",
    fill: "#455a64",
    style: {
      transformOrigin: "286.46px 332.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M287.11,346.19a13.58,13.58,0,0,1-.24-5.58,13.58,13.58,0,0,1,.24,5.58Z",
    fill: "#455a64",
    style: {
      transformOrigin: "286.99px 343.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M284.14,275.53a37.69,37.69,0,0,1-1.91,3.89c-1.2,2.39-2.8,5.71-4.39,9.46s-2.85,7.22-3.72,9.75a42.74,42.74,0,0,1-1.46,4.08,4.38,4.38,0,0,1,.22-1.15c.17-.73.46-1.77.85-3.06a101,101,0,0,1,3.57-9.84,102.5,102.5,0,0,1,4.57-9.43c.65-1.17,1.2-2.11,1.6-2.74A4.74,4.74,0,0,1,284.14,275.53Z",
    fill: "#455a64",
    style: {
      transformOrigin: "278.4px 289.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293.8,285.46c0,.09-1.45.67-3.73,1.84a48.9,48.9,0,0,0-8.36,5.48,47.8,47.8,0,0,0-7,7.14c-1.6,2-2.46,3.35-2.54,3.3a3.89,3.89,0,0,1,.51-1,29.16,29.16,0,0,1,1.7-2.55,40.88,40.88,0,0,1,15.51-12.73,25.24,25.24,0,0,1,2.83-1.17A3.86,3.86,0,0,1,293.8,285.46Z",
    fill: "#455a64",
    style: {
      transformOrigin: "282.985px 294.341px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M305.6,300.23a2.27,2.27,0,0,1-.08-.6c0-.46-.06-1-.1-1.71-.06-1.58-.15-3.71-.26-6.31s-.2-5.85-.31-9.35c-.08-1.75-.07-3.62-.21-5.5a33.26,33.26,0,0,0-1-5.78,20.49,20.49,0,0,0-1-2.8,7.92,7.92,0,0,0-1.62-2.3,14,14,0,0,0-4.45-3,13.59,13.59,0,0,0-4.74-1.18,38.58,38.58,0,0,0-4.33,0c-2.65.15-4.79.37-6.28.49l-1.71.13a2.3,2.3,0,0,1-.6,0,2.41,2.41,0,0,1,.59-.12l1.7-.24c1.48-.19,3.61-.47,6.28-.67a38.39,38.39,0,0,1,4.38-.11,13.84,13.84,0,0,1,4.92,1.17,14.65,14.65,0,0,1,4.65,3.11,8.47,8.47,0,0,1,1.73,2.46,19.35,19.35,0,0,1,1,2.89,33.44,33.44,0,0,1,1,5.88c.13,1.94.11,3.77.17,5.54.07,3.5.14,6.66.19,9.35s.06,4.74.08,6.31c0,.69,0,1.26,0,1.72A2.58,2.58,0,0,1,305.6,300.23Z",
    fill: "#455a64",
    style: {
      transformOrigin: "292.264px 280.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M276.41,263.25a3.1,3.1,0,0,1-.67.12l-1.93.25-7.11.86c-6,.71-14.3,1.72-23.45,2.92s-17.43,2.39-23.41,3.27l-7.09,1-1.93.26a5.78,5.78,0,0,1-.68.06,2.44,2.44,0,0,1,.66-.16l1.91-.36c1.67-.3,4.08-.71,7.07-1.19,6-1,14.24-2.2,23.4-3.41s17.46-2.16,23.48-2.78c3-.31,5.44-.55,7.13-.69l1.94-.15A3.17,3.17,0,0,1,276.41,263.25Z",
    fill: "#455a64",
    style: {
      transformOrigin: "243.275px 267.611px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m278.89 372.56-1.8-21.41h25.71l-0.7 20.94s-7.06 5.9-11.79 5.76-11.42-5.29-11.42-5.29z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "289.945px 364.501px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m277 356.83 2.31 32.35h52.81s2.13-4.54-1.2-6-28.07-8.81-28.07-8.81l-0.25-18.56z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "304.895px 372.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m274.82 357.22 0.91 6.67a2 2 0 0 0 2.07 1.71l23.43-1.25a2.06 2.06 0 0 0 1.94-1.91l0.46-6.56a2 2 0 0 0-2.06-2.12l-24.8 1.13a2.07 2.07 0 0 0-1.95 2.33z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "289.218px 359.681px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M302.45,364.4a3.79,3.79,0,0,1-1,.21c-.63.1-1.56.23-2.7.36-2.28.28-5.45.58-9,.73s-6.7.1-9,0c-1.15-.07-2.08-.13-2.72-.2a4,4,0,0,1-1-.16,31.2,31.2,0,0,1,3.72,0c2.29,0,5.46,0,9-.13s6.66-.39,8.95-.57A27.66,27.66,0,0,1,302.45,364.4Z",
    fill: "#263238",
    style: {
      transformOrigin: "289.74px 365.097px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m282.42 365.37a13.55 13.55 0 0 1-1.32-10.79 43.19 43.19 0 0 0 0 5.47 43 43 0 0 0 1.32 5.32z",
    fill: "#263238",
    style: {
      transformOrigin: "281.475px 359.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M288.83,365.35a41,41,0,0,1-.32-5.38,40.76,40.76,0,0,1-.15-5.39,33.59,33.59,0,0,1,.47,10.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "288.696px 359.965px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.58,365.21c-.16,0,.32-2.46.22-5.48s-.69-5.41-.54-5.45a13.33,13.33,0,0,1,1.06,5.43A13.49,13.49,0,0,1,296.58,365.21Z",
    fill: "#263238",
    style: {
      transformOrigin: "296.796px 359.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M287,389a17.56,17.56,0,0,1-.59-1.67,11,11,0,0,0-2.26-3.51,10.73,10.73,0,0,0-3.43-2.37,13.47,13.47,0,0,1-1.64-.66,4.09,4.09,0,0,1,1.78.31,9.47,9.47,0,0,1,5.89,6.11A3.82,3.82,0,0,1,287,389Z",
    fill: "#263238",
    style: {
      transformOrigin: "283.05px 384.892px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M318.75,388.42c-.06,0-.31-.47-.42-1.32a6.7,6.7,0,0,1,2.47-6,2.57,2.57,0,0,1,1.22-.64c0,.08-.4.35-1,.92a7.68,7.68,0,0,0-2.35,5.69A7.58,7.58,0,0,1,318.75,388.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "320.153px 384.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m237.49 111.2a25.59 25.59 0 0 0-18.45-8c-3.91 0-12.62 3.48-13.13 8.78 11.55 8 24.36 12.19 36.68 18.89 0.67-6.73-0.59-14.66-5.1-19.67z",
    fill: "#263238",
    style: {
      transformOrigin: "224.334px 117.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M213.09,198.05c-1.71.25-20.41-30.68-20.41-30.68l7.63-41.17c2.07-12.41,11-21.55,23.36-19.14l1.13.29A22.5,22.5,0,0,1,241.38,133c-1.86,10.75-4,22.6-5.56,28.23-3.15,11.65-15.31,10.47-15.31,10.47s-.61,2.73-1.34,6.19l-6.08,20.21Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "217.196px 152.386px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m220.48 171.79a29.12 29.12 0 0 1-14.06-8.41s1.52 9.46 13.46 11.4z",
    fill: "#eb996e",
    style: {
      transformOrigin: "213.45px 169.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M216.63,150.88a2.6,2.6,0,1,1,1.86,4.73,3.22,3.22,0,0,1-2.05-.42,2.43,2.43,0,0,1-1.13-1.11,2.29,2.29,0,0,1,.3-2.2,3.51,3.51,0,0,1,1.45-1.22",
    fill: "#eb996e",
    style: {
      transformOrigin: "217.913px 153.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m235.86 142.15a1.71 1.71 0 0 1-2 1.27 1.65 1.65 0 0 1-1.33-1.95 1.72 1.72 0 0 1 2-1.27 1.65 1.65 0 0 1 1.33 1.95z",
    fill: "#263238",
    style: {
      transformOrigin: "234.195px 141.811px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M237.44,138.08c-.26.16-1.29-1.1-3.09-1.56s-3.34.11-3.48-.16.24-.46.92-.73a4.76,4.76,0,0,1,2.86-.14A4.56,4.56,0,0,1,237,137C237.48,137.56,237.57,138,237.44,138.08Z",
    fill: "#263238",
    style: {
      transformOrigin: "234.168px 136.714px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m219.6 138.43a1.72 1.72 0 0 1-2 1.27 1.66 1.66 0 0 1-1.34-1.95 1.72 1.72 0 0 1 2-1.27 1.65 1.65 0 0 1 1.34 1.95z",
    fill: "#263238",
    style: {
      transformOrigin: "217.931px 138.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M220.05,134.07c-.27.16-1.29-1.1-3.09-1.55s-3.35.1-3.48-.17c-.07-.12.24-.46.92-.73a4.76,4.76,0,0,1,2.86-.14,4.59,4.59,0,0,1,2.38,1.51C220.09,133.56,220.17,134,220.05,134.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "216.785px 132.704px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M222.72,149a12,12,0,0,1,3.05.22c.47.07.93.09,1.09-.2a2.41,2.41,0,0,0,0-1.44c-.15-1.22-.3-2.5-.46-3.84-.61-5.46-.92-9.9-.7-9.92s.89,4.38,1.5,9.84q.21,2,.39,3.84a2.76,2.76,0,0,1-.22,1.87,1.17,1.17,0,0,1-.93.47,2.75,2.75,0,0,1-.8-.09A12.44,12.44,0,0,1,222.72,149Z",
    fill: "#263238",
    style: {
      transformOrigin: "225.192px 141.831px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m217.11 148.86c0.3 0.06-0.2 2 1.12 3.82s3.44 2.14 3.39 2.41-0.56 0.26-1.45 0.06a5 5 0 0 1-2.86-1.9 4.4 4.4 0 0 1-0.81-3.17c0.14-0.84 0.5-1.26 0.61-1.22z",
    fill: "#263238",
    style: {
      transformOrigin: "219.042px 152.077px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M221.89,127.06c-.3.44-2-.25-4.21-.54s-4-.15-4.19-.66c-.07-.24.34-.62,1.15-.92a7.41,7.41,0,0,1,6.4.91C221.73,126.36,222,126.85,221.89,127.06Z",
    fill: "#263238",
    style: {
      transformOrigin: "217.698px 125.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M238,132.81c-.42.32-1.55-.42-3-.82s-2.82-.43-3-.93c-.08-.24.23-.6.88-.84a4.52,4.52,0,0,1,4.86,1.41C238.16,132.18,238.23,132.64,238,132.81Z",
    fill: "#263238",
    style: {
      transformOrigin: "235.059px 131.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M217.08,112.8l9.61-8.38c-10.5-6.85-23.57,0-28.14,6.87-1.73,2.59-2.28,5.77-4.42,8-3.44,3.62-8.79,4.92-10.53,9.6-1.16,3.1.25,6.73-.93,9.83-1.95,5.11-9.89,6.44-10.77,11.83-.6,3.72,2.7,7.39,1.66,11-.74,2.59-3.5,3.9-5.37,5.84-7.08,7.35-5.33,17.35.67,21,2-4.18,4-9,7.71-12.21s7.83-5.64,12.67-4.95c2.86.41,5.35,1.07,7.79-.48,1.92-1.21,2.53-3.81,2.18-6s-1.46-4.29-2.28-6.41-1.36-4.51-.56-6.64c1.42-3.74,6.33-5.13,8-8.79,1.09-2.45.43-5.28-.06-7.93s-.72-5.66,1-7.73c2.47-3,8.12-2.92,9.05-6.67.41-1.66-.38-3.35-.65-5S215.38,112.92,217.08,112.8Z",
    fill: "#263238",
    style: {
      transformOrigin: "195.134px 144.987px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M181.35,173c2.75-1.71,7.63-2.44,10.41-1.48,3.44,1.18,4.21,3.58,5.64,6.16,5.41,9.71,10.79,19.5,14.57,29.95a16.71,16.71,0,0,0,5.15-15.25c-.46-2.38-1.44-4.68-1.42-7.1,0-2.26.91-4.46.89-6.72a8.58,8.58,0,0,0-4-7.11c-2.15-1.32-5.07-1.85-6.19-4.11-1.51-3,1.37-7-.4-9.91-1.39-2.25-4.85-2.4-6.36-4.58a5,5,0,0,1-.33-4.5c.54-1.47,3.74-2.21,4.77-4.9l-7.2-3.72L186,147.94s-5.83,24.25-5.23,24.66",
    fill: "#263238",
    style: {
      transformOrigin: "199.054px 173.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.27,205.42a20.26,20.26,0,0,0,1.94-2.38,13.69,13.69,0,0,0,2.23-7.9,13,13,0,0,0-1.45-5.5,54.3,54.3,0,0,1-3-6,15.9,15.9,0,0,1-.31-7.41,48.08,48.08,0,0,0,.68-7.86,97.38,97.38,0,0,0-1.6-15.16,114.09,114.09,0,0,1-1.52-12.42,41.42,41.42,0,0,1,.39-8.43c.15-1,.36-1.74.47-2.25a4.31,4.31,0,0,1,.21-.77,4.23,4.23,0,0,1-.11.8c-.07.51-.25,1.27-.37,2.25a44.19,44.19,0,0,0-.22,8.38,121.8,121.8,0,0,0,1.62,12.36,94,94,0,0,1,1.65,15.25,48.2,48.2,0,0,1-.69,7.91,15.49,15.49,0,0,0,.26,7.2,54.28,54.28,0,0,0,2.9,6,13.28,13.28,0,0,1,1.43,5.68,13.61,13.61,0,0,1-2.43,8A9.53,9.53,0,0,1,247.27,205.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "247.979px 167.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M197.45,116.44a5.67,5.67,0,0,1-.36.71,6.38,6.38,0,0,1-1.57,1.65,12.91,12.91,0,0,1-3.21,1.65c-1.3.52-2.83,1-4.42,1.69a7.89,7.89,0,0,0-4.12,3.62c-.92,1.81-.93,4.07-1,6.37a29.61,29.61,0,0,1-.2,3.6,8.88,8.88,0,0,1-1.2,3.6,8.72,8.72,0,0,1-2.85,2.72c-1.11.72-2.31,1.3-3.45,2a10.19,10.19,0,0,0-3,2.46,7.12,7.12,0,0,0-1.33,3.44c-.31,2.46.11,4.9.07,7.25a12.44,12.44,0,0,1-.46,3.42,11.59,11.59,0,0,1-1.41,2.94c-1.15,1.76-2.47,3.17-3.55,4.55a11.38,11.38,0,0,0-3,7.46,6.06,6.06,0,0,0,.93,2.84s0,0-.14-.15a4.44,4.44,0,0,1-.33-.49,5.35,5.35,0,0,1-.66-2.18c-.19-2,.67-4.95,2.92-7.71,1.07-1.4,2.38-2.83,3.48-4.55a11,11,0,0,0,1.33-2.84,11.78,11.78,0,0,0,.42-3.29c0-2.3-.4-4.74-.1-7.32a7.62,7.62,0,0,1,1.43-3.68,10.31,10.31,0,0,1,3.1-2.59c1.17-.7,2.36-1.28,3.44-2a8.36,8.36,0,0,0,2.7-2.55c1.31-2.1,1.29-4.64,1.35-6.93s.07-4.63,1.06-6.56a8.28,8.28,0,0,1,4.36-3.77c1.63-.71,3.17-1.14,4.47-1.62a13.17,13.17,0,0,0,3.19-1.55A7.7,7.7,0,0,0,197.45,116.44Z",
    fill: "#263238",
    style: {
      transformOrigin: "179.807px 147.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M232.86,108.34a24.31,24.31,0,0,0-23.42-2.27l3.51,7.59c1.77-.59,3.7.81,4.36,2.55a11.08,11.08,0,0,1,.15,5.52l12.28,4.17,1.17-3.75c.14,1.71.29,3.43.43,5.15a70.36,70.36,0,0,1,11.59,2.31A24.31,24.31,0,0,0,232.86,108.34Z",
    fill: "#263238",
    style: {
      transformOrigin: "226.209px 116.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M235.22,128.14c-.09,0,0-1.42-.15-3.68a28,28,0,0,0-.59-3.92,29.68,29.68,0,0,0-1.45-4.62,31,31,0,0,0-2.23-4.31,29,29,0,0,0-2.35-3.2c-1.47-1.72-2.54-2.63-2.48-2.71a4.34,4.34,0,0,1,.8.59,19.51,19.51,0,0,1,2,1.88,25.62,25.62,0,0,1,2.47,3.18,26,26,0,0,1,3.75,9.09,23.81,23.81,0,0,1,.49,4,19.77,19.77,0,0,1-.06,2.71A3.6,3.6,0,0,1,235.22,128.14Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "230.734px 116.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m309.72 221.79s-7.38-3.87-17.59 2l-4.91 1.88 1.53 5.93z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "298.47px 226.069px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M292.64,235.07s2.66-5.73,7.73-8.62a15.66,15.66,0,0,1,2.06-.8,24.67,24.67,0,0,1,7.29-1.31v-2.55s-7.06-2.95-14.23,2.92c-7.89,6.45-6.25,10.73-6.25,10.73l3.12-.34",
    fill: "#455a64",
    style: {
      transformOrigin: "299.409px 228.244px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M262.38,224.23s16.94-6.2,20.11-6c2,.12,2.94-.05,4.44,4.09,1.42,3.92,3.09,9.93,3.09,9.93l-46.89,23.17-.16-9.15,7.48-17.79Z",
    fill: "#455a64",
    style: {
      transformOrigin: "266.495px 236.823px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M251.36,233.42l23.82-7.74s3.92-6.57,7.81-6.09,5,5.91,5,5.91-1.73-8.84-6.11-8.07c-3.21.56-19.52,6.8-19.52,6.8l-10.69,8.91",
    fill: "#ebebeb",
    style: {
      transformOrigin: "269.675px 225.401px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "290.01 232.24 292.65 235.07 246.81 258.32 243.13 255.41",
    fill: "#455a64",
    style: {
      transformOrigin: "267.89px 245.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m262.79 223.88-11.55 9.63 9.7-3.15a9.82 9.82 0 0 1-3.29 6.47s1.13 3.63-1.19 5c0 0 0.75 2.12-2.75 4.39a34.48 34.48 0 0 1-9 3.57l-7.08 0.8a15.61 15.61 0 0 1-3.81-9.63c-0.14-5.8 0.79-6.59 0.79-6.59 0.26-0.71 6.69-8.82 8.19-9.13s8.54 1.61 8.54 1.61l5.53-2.42s3.4-1.8 4.22-1.58c0.01 0.04 1.63 0.29 1.7 1.03z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "248.298px 236.711px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m251.35 226.89c0.08 0.21-1.52 1-3.57 1.74s-3.76 1.21-3.84 1 1.53-1 3.57-1.74 3.77-1.2 3.84-1z",
    fill: "#eb996e",
    style: {
      transformOrigin: "247.645px 228.262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m257.72 236.64c0.11 0.19-0.91 1-2.32 1.63s-2.55 1.12-2.66 0.93 0.92-1 2.32-1.63 2.55-1.11 2.66-0.93z",
    fill: "#eb996e",
    style: {
      transformOrigin: "255.23px 237.922px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M252.64,243.8c-.09-.2.69-.79,1.74-1.32s2-.8,2.08-.61-.68.78-1.74,1.31S252.73,244,252.64,243.8Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "254.549px 242.836px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m289.74 232.37c0.07 0.13-10.25 5.28-23 11.5s-23.19 11.16-23.26 11 10.25-5.27 23-11.5 23.2-11.13 23.26-11z",
    fill: "#263238",
    style: {
      transformOrigin: "266.61px 243.621px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.25,237.58s-2.18.21-1.87,2.19l.32,2s-2.62-4.21-2.95-5.13c-1-2.68-3.32-1.34-2.87,1,.12.62.36,3.13.36,3.13s-.55-.82-2,.25c-.35.26-1,3.38-1,3.38l-2.72,1.81a15,15,0,0,0,.23,3.47,4.11,4.11,0,0,0,1.81,2.57c.41.33,5.28,4.13,6.75,3.88s2.53-1.6,2.48-2.12,2.19,0,3.22-1,1.1-1.17,1.15-1.44,2.52-1,3.3-1.86.63-1.44.63-1.44,2.21-.66,2.67-2a4,4,0,0,0,.47-2.8l-.33-1.56-1.79.9L273.4,241S270.6,237,269.25,237.58Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "267.904px 245.651px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m274.08 247.26c-0.09 0.18-2.17-0.75-4.19-2.65s-3.11-3.89-2.94-4 1.51 1.61 3.47 3.42 3.77 3.03 3.66 3.23z",
    fill: "#eb996e",
    style: {
      transformOrigin: "270.509px 243.943px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m268.78 249.47c-0.13 0.15-2.09-1.4-3.94-3.84s-2.79-4.76-2.6-4.84 1.42 2 3.22 4.37 3.48 4.14 3.32 4.31z",
    fill: "#eb996e",
    style: {
      transformOrigin: "265.503px 245.134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266.05,252.2c0,.1-.66.07-1.64-.27a8.26,8.26,0,0,1-3.34-2.25,8,8,0,0,1-1.81-3.6c-.2-1-.13-1.66,0-1.66.25-.06.46,2.52,2.44,4.74S266.14,252,266.05,252.2Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "262.594px 248.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M292.65,235.07a6.44,6.44,0,0,1-.8-.65l-2.2-1.95,0,0v0c-.25-1.13-.59-2.5-1.06-4.05a31.83,31.83,0,0,0-1.94-5,10.78,10.78,0,0,0-1.7-2.49,3.52,3.52,0,0,0-1.25-.85c-.23-.08-.49-.09-.74-.15a4.81,4.81,0,0,0-3.72,1.59,18.42,18.42,0,0,0-2.48,2.58,22.34,22.34,0,0,0-1.32,1.81l0,.08-.09,0c-6.61,2.18-12.4,4.45-16.7,5.71-2.14.65-3.89,1.1-5.1,1.36-.61.15-1.08.23-1.4.29a1.56,1.56,0,0,1-.5.06,2.62,2.62,0,0,1,.47-.16l1.38-.37c1.2-.33,2.92-.83,5-1.52,4.26-1.34,10-3.66,16.65-5.86l-.14.11a22.5,22.5,0,0,1,1.35-1.87,18.85,18.85,0,0,1,2.56-2.64,7.2,7.2,0,0,1,3.18-1.65,6.79,6.79,0,0,1,.9,0,8.06,8.06,0,0,1,.88.19,3.88,3.88,0,0,1,1.42,1,10.39,10.39,0,0,1,1.76,2.62,31.42,31.42,0,0,1,1.9,5.12c.44,1.56.75,2.95,1,4.1l0-.07,2.12,2A5.26,5.26,0,0,1,292.65,235.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "272.15px 227.253px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M236.15,234.38s-20.76,6.1-26.18,7.43c-3.85.94-16.89,2.86-16.89,2.86l-25.89,12.1c.86,8.6,4,14.63,9,15.45s25.55-4.53,37.71-10.71a268.93,268.93,0,0,1,25.45-11.07Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "203.27px 253.342px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m183.21 176a7.71 7.71 0 0 0-4.41 2.37c-2.66 2.81-7.39 9.31-9.4 21.45-2.87 17.36-2.21 57-2.21 57l27.45-11.49s2.62-38 2.91-48.3c0.24-8.9-3.55-22.69-14.34-21.03z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "182.343px 216.341px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m196.11 244.44a19.9 19.9 0 0 0-5.72 2.18 20.38 20.38 0 0 0-4.46 4.2 4.54 4.54 0 0 1 0.9-1.62 12.29 12.29 0 0 1 3.29-3 12.12 12.12 0 0 1 4.15-1.64 4.32 4.32 0 0 1 1.84-0.12z",
    fill: "#eb996e",
    style: {
      transformOrigin: "191.02px 247.606px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "250px 455.11px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M456.59,455.11c0,.14-92.5.26-206.58.26s-206.6-.12-206.6-.26,92.48-.26,206.6-.26S456.59,455,456.59,455.11Z",
    fill: "#263238",
    style: {
      transformOrigin: "250px 455.11px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "101.99px 383.835px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.7,369.14c0-.41-.08-.82-.14-1.23s-.12-.86-.2-1.29c.08.43.14.86.2,1.29S140.66,368.73,140.7,369.14Z",
    fill: "#f90",
    style: {
      transformOrigin: "140.53px 367.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M137.36,374.25a18.28,18.28,0,0,1-.68-2.54,1.65,1.65,0,0,0-.78-1.14,5.59,5.59,0,0,0-.92-.21c-1.09-.32-1.39-1.83-2.42-2.29a3.39,3.39,0,0,0-1-.22,5.44,5.44,0,0,1-3.67-1.7,6.64,6.64,0,0,0-.85-1,1,1,0,0,0-1.25-.11c.29.57.58,1.15.86,1.72a4.58,4.58,0,0,0,1,1.43,1.58,1.58,0,0,0,1.63.35,1.1,1.1,0,0,1,.54-.19.6.6,0,0,1,.36.22,2.35,2.35,0,0,1-.23,3,7,7,0,0,1-2.85,1.69,2.29,2.29,0,0,1-1.17.22c-.72-.13-1.1-.91-1.31-1.61-.48-1.54-.7-3.22-1.67-4.52a5.71,5.71,0,0,1-.88-1.26c-.2-.52-.15-1.13-.47-1.58s-1-.76-1.06-1.33a1,1,0,0,1,.68-.93c.37-.18.79-.24,1.18-.39.15-.06.32-.17.32-.34s-.34-.33-.42-.56.17-.49.28-.74c.24-.56-.36-1.13-.93-1.36s-1.27-.4-1.54-1a3.32,3.32,0,0,1-.18-.83,1.82,1.82,0,0,0-1.37-1.48,1.19,1.19,0,0,0-1.39,1.21,4.6,4.6,0,0,0,.52,1c.16.36.12.89-.26,1-.61.18-1.2-.92-1.71-.54.21.7.41,1.41.62,2.13-.8.4-1.76-.33-2.1-1.16s-.36-1.77-.77-2.56-1.51-1.4-2.2-.83c0,1,1.33,1.44,1.93,2.27a1.37,1.37,0,0,1-.27,1.95c-.64.38-1.66-.28-1.41-1,.08-.24.29-.44.31-.7a1,1,0,0,0-.5-.79l-1.17-1a2.76,2.76,0,0,0-.83-.52,2,2,0,0,0-2,1.13,9.91,9.91,0,0,1-1.25,2.14,2.3,2.3,0,0,1-3.24,0,1.87,1.87,0,0,1,.78-2.92c.44-.12,1-.11,1.24-.5.4-.68-.76-1.56-.36-2.25.31-.53,1.13-.29,1.72-.47s.92-.77,1.27-1.27.89-1,1.49-.88a1.78,1.78,0,0,1,.07-1.05.65.65,0,0,1,.89-.32,1.05,1.05,0,0,0,.57,1.4,3.15,3.15,0,0,0,1.7.12c.57-.07,1.29-.27,1.33-.84,0-.18-.05-.38,0-.55.25-.68,1.51.25,2-.29.28-.28,0-.78-.42-.88a4.72,4.72,0,0,0-1.18.06c-.4,0-.88-.19-.9-.58s.42-.66.47-1c.07-.65-1-.82-1.42-.29a2.43,2.43,0,0,0-.14,1.88,2,2,0,0,1-.29,1.85c-.21.3-.74.14-.91-.18a2.64,2.64,0,0,1-.17-1.08.93.93,0,0,0-.55-.88,2.08,2.08,0,0,0-.78.08c-1,.13-1.72-1.17-1.4-2.13a4.14,4.14,0,0,1,2.13-2.07A2.26,2.26,0,0,1,112,344c.3.16.51.45.81.62a3.57,3.57,0,0,0,1.73.21,4.07,4.07,0,0,1,2.54,1c.26.24.5.63.3.91s-.86.36-.75.71a1.27,1.27,0,0,0,1.59-1,1,1,0,0,1,.61.85,1.9,1.9,0,0,1,2.77.22,2.2,2.2,0,0,0,.51.65c.23.15.64.08.67-.19a.53.53,0,0,0,0-.25c-.14-.4-.28-.78-.42-1.17.54-.29,1.18.16,1.55.65,1.36,1.8,2.33.72,4.25,1,1.3.2,1.87,1,2.61,2,2.25,3.06,5.22,5.57,7.26,8.78a10.47,10.47,0,0,1,.6,1,2.77,2.77,0,0,0-.1-.26,35.43,35.43,0,0,0-3-6c-.25-.4-.5-.8-.77-1.19s-.33-.49-.5-.72-.44-.62-.67-.92-.36-.47-.55-.7-.26-.33-.39-.49-.29-.36-.46-.54l-.48-.56-.16-.17c-.17-.2-.35-.39-.53-.58l-.05-.06-.16-.15c-.14-.16-.3-.32-.45-.47s-.51-.51-.77-.75-.44-.42-.66-.62l-.6-.53-.6-.51-.75-.61h0c-.71-.56-1.43-1.09-2.18-1.58l-.55-.37-.57-.36-.57-.34-.57-.34L122,341l-.24-.13c-.33-.19-.67-.37-1-.53-.17-.09-.33-.18-.51-.26l-.66-.31-.1-.05-.6-.27-.85-.35-1-.39c-.36-.14-.73-.27-1.1-.39l-1.13-.36c-.38-.12-.76-.22-1.15-.33-.75-.2-1.52-.38-2.3-.53h0l-.89-.17h-.06l-.39-.06c-.56-.09-1.12-.17-1.68-.23l-.2,0-.5-.06-1.12-.08c-.39,0-.79-.05-1.19-.06s-.82,0-1.24,0c-1.09,0-2.18,0-3.25.14l-.75.07-.79.09-.78.11-.78.13c-.22,0-.45.07-.67.12-.55.1-1.09.22-1.63.34l-.75.2-.74.2c-.42.11-.82.24-1.22.37h0l-1,.32,0,0c-.33.11-.65.23-1,.36l0,0-.89.35q-.54.22-1.08.48c-.3.13-.6.27-.89.42l-.94.47,0,0c-.3.15-.6.31-.89.48s-.6.34-.89.52h0l-.83.51-.31.2-.85.57c-.35.24-.69.49-1,.74s-.59.44-.87.66a36.59,36.59,0,0,0-4.58,4.3c-.5.54-1,1.09-1.42,1.66s-.75,1-1.11,1.48-.63.89-.92,1.34c.29-.45.6-.9.92-1.34l.28,0a4.42,4.42,0,0,0,1.55-.25,8.06,8.06,0,0,0,1.14-.88c1-.71,2.68-.84,3-2a8.41,8.41,0,0,1,.13-1.23c.29-.72,1.26-.82,2-.81.33,0,.72.05.88.33a.83.83,0,0,1,0,.67,6.28,6.28,0,0,1-2.67,3.25c-1,.61-2.34,1.08-2.62,2.23.14.38.85.35.91.76s-.38.49-.53.77.29.94.77.91a2.07,2.07,0,0,0,1.24-.69,7.87,7.87,0,0,0,2.56-3.4,2.94,2.94,0,0,1,.69-1.62,1.14,1.14,0,0,1,1.73.55c.46-.26,1.17-.45,1.41,0a2.54,2.54,0,0,1,.1.55c.15.73,1.17,1.07,1.28,1.81s-1,1.3-1.86,1.44l-2.36.36a2.19,2.19,0,0,0-1,.32.75.75,0,0,0-.29.9,2,2,0,0,0,.41.42,1.24,1.24,0,0,1-.81,2c-.31,0-.62-.1-.94-.11a2.54,2.54,0,0,0-2.11,1.58,6.34,6.34,0,0,1-1.52,2.29c-1.2.9-3.27.69-3.85,2.06a3.32,3.32,0,0,0,0,1.77,2.29,2.29,0,0,1-.21,1.73c-.35.49-1.24.59-1.5.05a1.34,1.34,0,0,1,0-.77c.14-.85.28-1.7.41-2.56a2.47,2.47,0,0,0-.19-1.86,1.73,1.73,0,0,0-2.41-.07,4.15,4.15,0,0,0-1.15,2.36,10.07,10.07,0,0,1-.67,2.29h0c-.12.72-.22,1.44-.3,2.18s-.12,1.49-.15,2.25a3.69,3.69,0,0,0,.29-.28c.37-.37,1.11-2,1.77-1.18a.59.59,0,0,1,0,.72c-.21.26-.62.32-.77.6s.07.75.39,1a3.28,3.28,0,0,1,.92.68c.42.6,0,1.52.43,2.14s1.11.56,1.76.63l.22,0a2.93,2.93,0,0,1,2.53-2.7c2.41-.54,5.58,1.44,6.93,3.24,1.52,2,2.24,4.85,4.55,5.86,1.66.72,4,.46,4.83,2.07.72,1.44-.53,3.06-.73,4.66a16.82,16.82,0,0,0,.31,3.15,2.69,2.69,0,0,1-1.21,2.74c-.54.24-1.22.21-1.66.62-.77.72-.14,2.22-.91,2.95a4.41,4.41,0,0,1-1,.51c-1.74.87-1.69,3.41-.88,5.16a1.54,1.54,0,0,1,.08.19,37.2,37.2,0,0,0,36.15.9h0a37.24,37.24,0,0,0,7.83-5.53,38,38,0,0,0,2.79-2.89c.62-.7,1.2-1.44,1.76-2.19.29-.38.57-.77.83-1.17a35,35,0,0,0,2.2-3.63,35.48,35.48,0,0,0,2.38-5.68,34.32,34.32,0,0,0,1.4-6.17c.11-.82.2-1.65.26-2.49a2.08,2.08,0,0,1-1.48.65A2.37,2.37,0,0,1,137.36,374.25Z",
    fill: "#f90",
    style: {
      transformOrigin: "104.255px 372.828px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.29,345.87c-.73.44-1.11,1.25-1.68,1.88s-1.57,1.08-2.23.55a1.51,1.51,0,0,1-.5-1.07,2.73,2.73,0,0,1,.4-1.67c.31-.51.8-.91,1.06-1.45a1.16,1.16,0,0,0-.33-1.57c-.3-.14-.67-.09-.94-.28-.47-.34-.13-1.16.42-1.37a4.48,4.48,0,0,1,1.75,0c2.13.14,3.7-1.24,5.31-2.39,1.24-.9,3.9-1.95,5.34-1,.58.37.81,1.3.26,1.71-.24.19-.57.23-.8.43s-.31.65-.47,1c-.4.85-1.56,1.16-1.94,2-.22.52-.12,1.17-.47,1.62a2,2,0,0,1-1.2.59l-2.78.65A4.6,4.6,0,0,0,95.29,345.87Z",
    fill: "#f90",
    style: {
      transformOrigin: "97.6554px 342.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.17,390.69a11.45,11.45,0,0,0-1.35,4.73,7.12,7.12,0,0,1-2,4.44c-1.27,1.07-3.6,1-4.3-.49a13.66,13.66,0,0,1-.39-2.65c-.27-1.14-1.18-2-1.62-3.1a8.54,8.54,0,0,1-.4-2.94c-.16-5.44-1.5-11.12-5.25-15.11a3.62,3.62,0,0,0-1.63-1.14,2.11,2.11,0,0,0-2.15.73,7.57,7.57,0,0,1-.83,1.23,1.9,1.9,0,0,1-2.73-.73,5.39,5.39,0,0,1-.37-3.14l.33-4a3.35,3.35,0,0,1,.6-2c.65-.74,1.83-.78,2.63-1.37,1-.78,1.18-2.26,1.84-3.38s2.74-1.59,3-.33c2.19-4.64,7,2.25,9.91,1.73a8,8,0,0,1,2.49-.43c1.48.21,2.25,1.82,2.75,3.22l2.52,7a3.33,3.33,0,0,0,1.62,2.21c.67.26,1.46.06,2.14.31,1.81.65,1.22,3.46-.23,4.7s-3.49,2-4.18,3.8c-.52,1.34-.11,2.9-.67,4.22A16,16,0,0,1,120.17,390.69Z",
    fill: "#f90",
    style: {
      transformOrigin: "112.584px 380.206px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127,392.2c-.59.08-1.29-.21-1.74.19a1.78,1.78,0,0,0-.43.93,2,2,0,0,1-.84,1.13,1.26,1.26,0,0,1-1.37,0,.9.9,0,0,1-.19-1.27,5.17,5.17,0,0,1,.51-.42c.79-.73.25-2.1.85-3,.35-.52.91-1,1.29-1.57s.41-.72,1-.82C128.46,386.91,129.54,391.85,127,392.2Z",
    fill: "#f90",
    style: {
      transformOrigin: "125.354px 390.996px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M72.09,382.32a24,24,0,0,1,.25-3.14c0-.72,0-1.49,0-2.22a10.66,10.66,0,0,1-1.87-.26.57.57,0,0,1-.35-.18.61.61,0,0,1-.07-.38c0-.82-.85-1.36-1.56-1.77a6.29,6.29,0,0,0-1.14-.55,2.18,2.18,0,0,0,0,.25,35.78,35.78,0,0,0,2.34,11.55,34.07,34.07,0,0,0,2.25,4.77c.36.67.75,1.32,1.17,2s1,1.56,1.62,2.3,1.11,1.41,1.71,2.08a36.12,36.12,0,0,0,2.6,2.65c.81.75,1.66,1.46,2.54,2.13-2-5.33-3.91-10.78-7.34-15.32C73.29,385,72.26,383.8,72.09,382.32Z",
    fill: "#f90",
    style: {
      transformOrigin: "74.4632px 387.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.29 372.09v0.66s0 0.36 0 0.53v-0.53s0-0.44 0-0.66z",
    fill: "#f90",
    style: {
      transformOrigin: "67.29px 372.685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.6,403c.3.21.62.41.93.6l.67.41-.67-.41C84.22,403.4,83.9,403.2,83.6,403Z",
    fill: "#f90",
    style: {
      transformOrigin: "84.4px 403.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.32 371.24a1.27 1.27 0 0 0 0 0.2v0.65-0.65a1.27 1.27 0 0 1 0-0.2z",
    fill: "#f90",
    style: {
      transformOrigin: "67.318px 371.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.29 373.28v0.54-0.54z",
    fill: "#f90",
    style: {
      transformOrigin: "67.29px 373.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M72.35,375.55l-.22,0c-.65-.07-1.41-.1-1.76-.63s0-1.54-.43-2.14a3.28,3.28,0,0,0-.92-.68c-.32-.22-.58-.63-.39-1s.56-.34.77-.6a.59.59,0,0,0,0-.72c-.66-.78-1.4.81-1.77,1.18a3.69,3.69,0,0,1-.29.28h0a1.27,1.27,0,0,0,0,.2c0,.21,0,.43,0,.65s0,.44,0,.66,0,.36,0,.53,0,.36,0,.54a6.29,6.29,0,0,1,1.14.55c.71.41,1.51.95,1.56,1.77a.61.61,0,0,0,.07.38.57.57,0,0,0,.35.18,10.66,10.66,0,0,0,1.87.26",
    fill: "#f90",
    style: {
      transformOrigin: "69.843px 373.264px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M72.29,377c0,.73.06,1.5,0,2.22a24,24,0,0,0-.25,3.14c.17,1.48,1.2,2.69,2.11,3.87,3.43,4.54,5.33,10,7.34,15.32h0c.37.3.75.57,1.14.85l.92.63c.3.21.62.41.93.6l.67.41a1.54,1.54,0,0,0-.08-.19c-.81-1.75-.86-4.29.88-5.16a4.41,4.41,0,0,0,1-.51c.77-.73.14-2.23.91-2.95.44-.41,1.12-.38,1.66-.62a2.69,2.69,0,0,0,1.21-2.74,16.82,16.82,0,0,1-.31-3.15c.2-1.6,1.45-3.22.73-4.66-.81-1.61-3.17-1.35-4.83-2.07-2.31-1-3-3.85-4.55-5.86-1.35-1.8-4.52-3.78-6.93-3.24a2.93,2.93,0,0,0-2.53,2.7",
    fill: "#f90",
    style: {
      transformOrigin: "81.7057px 388.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.59,362.15a1.73,1.73,0,0,1,2.41.07,2.47,2.47,0,0,1,.19,1.86c-.13.86-.27,1.71-.41,2.56a1.34,1.34,0,0,0,0,.77c.26.54,1.15.44,1.5-.05a2.29,2.29,0,0,0,.21-1.73,3.32,3.32,0,0,1,0-1.77c.58-1.37,2.65-1.16,3.85-2.06a6.34,6.34,0,0,0,1.52-2.29A2.54,2.54,0,0,1,81,357.93c.32,0,.63.12.94.11a1.24,1.24,0,0,0,.81-2,2,2,0,0,1-.41-.42.75.75,0,0,1,.29-.9,2.19,2.19,0,0,1,1-.32L86,354c.86-.14,2-.58,1.86-1.44s-1.13-1.08-1.28-1.81a2.54,2.54,0,0,0-.1-.55c-.24-.47-1-.28-1.41,0a1.14,1.14,0,0,0-1.73-.55,2.94,2.94,0,0,0-.69,1.62,7.87,7.87,0,0,1-2.56,3.4,2.07,2.07,0,0,1-1.24.69c-.48,0-1-.49-.77-.91s.57-.45.53-.77-.77-.38-.91-.76c.28-1.15,1.6-1.62,2.62-2.23A6.28,6.28,0,0,0,83,347.46a.83.83,0,0,0,0-.67c-.16-.28-.55-.33-.88-.33-.78,0-1.75.09-2,.81A8.41,8.41,0,0,0,80,348.5c-.27,1.2-1.93,1.33-3,2a8.06,8.06,0,0,1-1.14.88,4.42,4.42,0,0,1-1.55.25l-.28,0c-.32.44-.63.89-.92,1.34s-.59.92-.87,1.39a36.67,36.67,0,0,0-3.19,7c-.28.87-.54,1.74-.75,2.63s-.41,1.79-.56,2.7a10.07,10.07,0,0,0,.67-2.29A4.15,4.15,0,0,1,69.59,362.15Z",
    fill: "#f90",
    style: {
      transformOrigin: "77.8059px 357.117px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m140.87 372.25v-1.56 1.56 0.5c0 0.81 0 1.6-0.07 2.4 0.05-0.8 0.07-1.59 0.07-2.4 0.01-0.17 0.01-0.33 0-0.5z",
    fill: "#f90",
    style: {
      transformOrigin: "140.839px 372.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.57,360c.18.47.34.93.5,1.4-.16-.47-.32-.93-.5-1.4Z",
    fill: "#f90",
    style: {
      transformOrigin: "138.82px 360.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.87,372.25c0-.52,0-1,0-1.56s-.07-1-.13-1.55-.08-.82-.14-1.23-.12-.86-.2-1.29a32.32,32.32,0,0,0-.86-3.78c-.13-.48-.28-.95-.43-1.41s-.32-.93-.5-1.4h0a10.47,10.47,0,0,0-.6-1c-2-3.21-5-5.72-7.26-8.78-.74-1-1.31-1.82-2.61-2-1.92-.29-2.89.79-4.25-1-.37-.49-1-.94-1.55-.65.14.39.28.77.42,1.17a.53.53,0,0,1,0,.25c0,.27-.44.34-.67.19a2.2,2.2,0,0,1-.51-.65,1.9,1.9,0,0,0-2.77-.22,1,1,0,0,0-.61-.85,1.27,1.27,0,0,1-1.59,1c-.11-.35.53-.41.75-.71s0-.67-.3-.91a4.07,4.07,0,0,0-2.54-1,3.57,3.57,0,0,1-1.73-.21c-.3-.17-.51-.46-.81-.62a2.26,2.26,0,0,0-2.11.32,4.14,4.14,0,0,0-2.13,2.07c-.32,1,.39,2.26,1.4,2.13a2.08,2.08,0,0,1,.78-.08.93.93,0,0,1,.55.88,2.64,2.64,0,0,0,.17,1.08c.17.32.7.48.91.18a2,2,0,0,0,.29-1.85,2.43,2.43,0,0,1,.14-1.88c.39-.53,1.49-.36,1.42.29,0,.38-.48.65-.47,1s.5.6.9.58a4.72,4.72,0,0,1,1.18-.06c.39.1.7.6.42.88-.48.54-1.74-.39-2,.29-.07.17,0,.37,0,.55,0,.57-.76.77-1.33.84a3.15,3.15,0,0,1-1.7-.12,1.05,1.05,0,0,1-.57-1.4.65.65,0,0,0-.89.32,1.78,1.78,0,0,0-.07,1.05c-.6-.13-1.15.38-1.49.88s-.68,1.09-1.27,1.27-1.41-.06-1.72.47c-.4.69.76,1.57.36,2.25-.24.39-.8.38-1.24.5a1.87,1.87,0,0,0-.78,2.92,2.3,2.3,0,0,0,3.24,0,9.91,9.91,0,0,0,1.25-2.14,2,2,0,0,1,2-1.13,2.76,2.76,0,0,1,.83.52l1.17,1a1,1,0,0,1,.5.79c0,.26-.23.46-.31.7-.25.7.77,1.36,1.41,1a1.37,1.37,0,0,0,.27-1.95c-.6-.83-2-1.25-1.93-2.27.69-.57,1.8,0,2.2.83s.42,1.74.77,2.56,1.3,1.56,2.1,1.16c-.21-.72-.41-1.43-.62-2.13.51-.38,1.1.72,1.71.54.38-.12.42-.65.26-1a4.6,4.6,0,0,1-.52-1,1.19,1.19,0,0,1,1.39-1.21,1.82,1.82,0,0,1,1.37,1.48,3.32,3.32,0,0,0,.18.83c.27.55,1,.72,1.54,1s1.17.8.93,1.36c-.11.25-.38.49-.28.74s.42.32.42.56-.17.28-.32.34c-.39.15-.81.21-1.18.39a1,1,0,0,0-.68.93c0,.57.74.85,1.06,1.33s.27,1.06.47,1.58a5.71,5.71,0,0,0,.88,1.26c1,1.3,1.19,3,1.67,4.52.21.7.59,1.48,1.31,1.61a2.29,2.29,0,0,0,1.17-.22,7,7,0,0,0,2.85-1.69,2.35,2.35,0,0,0,.23-3,.6.6,0,0,0-.36-.22,1.1,1.1,0,0,0-.54.19,1.58,1.58,0,0,1-1.63-.35,4.58,4.58,0,0,1-1-1.43c-.28-.57-.57-1.15-.86-1.72a1,1,0,0,1,1.25.11,6.64,6.64,0,0,1,.85,1,5.44,5.44,0,0,0,3.67,1.7,3.39,3.39,0,0,1,1,.22c1,.46,1.33,2,2.42,2.29a5.59,5.59,0,0,1,.92.21,1.65,1.65,0,0,1,.78,1.14,18.28,18.28,0,0,0,.68,2.54,2.37,2.37,0,0,0,2,1.55,2.08,2.08,0,0,0,1.48-.65h0c.05-.8.07-1.59.07-2.4C140.88,372.58,140.88,372.42,140.87,372.25Z",
    fill: "#f90",
    style: {
      transformOrigin: "121.594px 359.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.06,387.38c-.55.1-.66.42-1,.82s-.94,1.05-1.29,1.57c-.6.87-.06,2.24-.85,3a5.17,5.17,0,0,0-.51.42.9.9,0,0,0,.19,1.27,1.26,1.26,0,0,0,1.37,0,2,2,0,0,0,.84-1.13,1.78,1.78,0,0,1,.43-.93c.45-.4,1.15-.11,1.74-.19C129.54,391.85,128.46,386.91,126.06,387.38Z",
    fill: "#f90",
    style: {
      transformOrigin: "125.341px 391.005px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "140.53px 367.88px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.7,369.14c0-.41-.08-.82-.14-1.23s-.12-.86-.2-1.29c.08.43.14.86.2,1.29S140.66,368.73,140.7,369.14Z",
    style: {
      transformOrigin: "140.53px 367.88px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "97.6554px 342.83px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.29,345.87c-.73.44-1.11,1.25-1.68,1.88s-1.57,1.08-2.23.55a1.51,1.51,0,0,1-.5-1.07,2.73,2.73,0,0,1,.4-1.67c.31-.51.8-.91,1.06-1.45a1.16,1.16,0,0,0-.33-1.57c-.3-.14-.67-.09-.94-.28-.47-.34-.13-1.16.42-1.37a4.48,4.48,0,0,1,1.75,0c2.13.14,3.7-1.24,5.31-2.39,1.24-.9,3.9-1.95,5.34-1,.58.37.81,1.3.26,1.71-.24.19-.57.23-.8.43s-.31.65-.47,1c-.4.85-1.56,1.16-1.94,2-.22.52-.12,1.17-.47,1.62a2,2,0,0,1-1.2.59l-2.78.65A4.6,4.6,0,0,0,95.29,345.87Z",
    style: {
      transformOrigin: "97.6554px 342.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "112.584px 380.206px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M120.17,390.69a11.45,11.45,0,0,0-1.35,4.73,7.12,7.12,0,0,1-2,4.44c-1.27,1.07-3.6,1-4.3-.49a13.66,13.66,0,0,1-.39-2.65c-.27-1.14-1.18-2-1.62-3.1a8.54,8.54,0,0,1-.4-2.94c-.16-5.44-1.5-11.12-5.25-15.11a3.62,3.62,0,0,0-1.63-1.14,2.11,2.11,0,0,0-2.15.73,7.57,7.57,0,0,1-.83,1.23,1.9,1.9,0,0,1-2.73-.73,5.39,5.39,0,0,1-.37-3.14l.33-4a3.35,3.35,0,0,1,.6-2c.65-.74,1.83-.78,2.63-1.37,1-.78,1.18-2.26,1.84-3.38s2.74-1.59,3-.33c2.19-4.64,7,2.25,9.91,1.73a8,8,0,0,1,2.49-.43c1.48.21,2.25,1.82,2.75,3.22l2.52,7a3.33,3.33,0,0,0,1.62,2.21c.67.26,1.46.06,2.14.31,1.81.65,1.22,3.46-.23,4.7s-3.49,2-4.18,3.8c-.52,1.34-.11,2.9-.67,4.22A16,16,0,0,1,120.17,390.69Z",
    style: {
      transformOrigin: "112.584px 380.206px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "67.29px 372.685px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.29 372.09v0.66s0 0.36 0 0.53v-0.53s0-0.44 0-0.66z",
    style: {
      transformOrigin: "67.29px 372.685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "84.4px 403.505px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.6,403c.3.21.62.41.93.6l.67.41-.67-.41C84.22,403.4,83.9,403.2,83.6,403Z",
    style: {
      transformOrigin: "84.4px 403.505px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "67.318px 371.665px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.32 371.24a1.27 1.27 0 0 0 0 0.2v0.65-0.65a1.27 1.27 0 0 1 0-0.2z",
    style: {
      transformOrigin: "67.318px 371.665px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "67.29px 373.55px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.29 373.28v0.54-0.54z",
    style: {
      transformOrigin: "67.29px 373.55px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "79.3737px 386.804px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90.46,388.68c.2-1.6,1.45-3.22.73-4.66-.81-1.61-3.17-1.35-4.83-2.07-2.31-1-3-3.85-4.55-5.86-1.35-1.8-4.52-3.78-6.93-3.24a2.93,2.93,0,0,0-2.53,2.7l-.22,0c-.65-.07-1.41-.1-1.76-.63s0-1.54-.43-2.14a3.28,3.28,0,0,0-.92-.68c-.32-.22-.58-.63-.39-1s.56-.34.77-.6a.59.59,0,0,0,0-.72c-.66-.78-1.4.81-1.77,1.18a3.69,3.69,0,0,1-.29.28h0a1.27,1.27,0,0,0,0,.2c0,.21,0,.43,0,.65s0,.44,0,.66,0,.36,0,.53,0,.36,0,.54a2.18,2.18,0,0,0,0,.25,35.78,35.78,0,0,0,2.34,11.55,35.19,35.19,0,0,0,2.24,4.77c.37.67.76,1.32,1.18,2s1,1.56,1.62,2.3,1.11,1.41,1.71,2.08a36.12,36.12,0,0,0,2.6,2.65c.81.75,1.66,1.46,2.54,2.13h0c.37.3.75.57,1.14.85l.92.63c.3.21.62.41.93.6l.67.41a1.54,1.54,0,0,0-.08-.19c-.81-1.75-.86-4.29.88-5.16a4.41,4.41,0,0,0,1-.51c.77-.73.14-2.23.91-2.95.44-.41,1.12-.38,1.66-.62a2.69,2.69,0,0,0,1.21-2.74A16.82,16.82,0,0,1,90.46,388.68ZM70,376.14a.61.61,0,0,0,.07.38A.61.61,0,0,1,70,376.14Z",
    style: {
      transformOrigin: "79.3737px 386.804px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "77.8059px 357.117px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.59,362.15a1.73,1.73,0,0,1,2.41.07,2.47,2.47,0,0,1,.19,1.86c-.13.86-.27,1.71-.41,2.56a1.34,1.34,0,0,0,0,.77c.26.54,1.15.44,1.5-.05a2.29,2.29,0,0,0,.21-1.73,3.32,3.32,0,0,1,0-1.77c.58-1.37,2.65-1.16,3.85-2.06a6.34,6.34,0,0,0,1.52-2.29A2.54,2.54,0,0,1,81,357.93c.32,0,.63.12.94.11a1.24,1.24,0,0,0,.81-2,2,2,0,0,1-.41-.42.75.75,0,0,1,.29-.9,2.19,2.19,0,0,1,1-.32L86,354c.86-.14,2-.58,1.86-1.44s-1.13-1.08-1.28-1.81a2.54,2.54,0,0,0-.1-.55c-.24-.47-1-.28-1.41,0a1.14,1.14,0,0,0-1.73-.55,2.94,2.94,0,0,0-.69,1.62,7.87,7.87,0,0,1-2.56,3.4,2.07,2.07,0,0,1-1.24.69c-.48,0-1-.49-.77-.91s.57-.45.53-.77-.77-.38-.91-.76c.28-1.15,1.6-1.62,2.62-2.23A6.28,6.28,0,0,0,83,347.46a.83.83,0,0,0,0-.67c-.16-.28-.55-.33-.88-.33-.78,0-1.75.09-2,.81A8.41,8.41,0,0,0,80,348.5c-.27,1.2-1.93,1.33-3,2a8.06,8.06,0,0,1-1.14.88,4.42,4.42,0,0,1-1.55.25l-.28,0c-.32.44-.63.89-.92,1.34s-.59.92-.87,1.39a36.67,36.67,0,0,0-3.19,7c-.28.87-.54,1.74-.75,2.63s-.41,1.79-.56,2.7a10.07,10.07,0,0,0,.67-2.29A4.15,4.15,0,0,1,69.59,362.15Z",
    style: {
      transformOrigin: "77.8059px 357.117px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "140.839px 372.92px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m140.87 372.25v-1.56 1.56 0.5c0 0.81 0 1.6-0.07 2.4 0.05-0.8 0.07-1.59 0.07-2.4 0.01-0.17 0.01-0.33 0-0.5z",
    style: {
      transformOrigin: "140.839px 372.92px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "138.82px 360.7px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M138.57,360c.18.47.34.93.5,1.4-.16-.47-.32-.93-.5-1.4Z",
    style: {
      transformOrigin: "138.82px 360.7px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "121.594px 359.915px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M140.87,372.25c0-.52,0-1,0-1.56s-.07-1-.13-1.55-.08-.82-.14-1.23-.12-.86-.2-1.29a32.32,32.32,0,0,0-.86-3.78c-.13-.48-.28-.95-.43-1.41s-.32-.93-.5-1.4h0a10.47,10.47,0,0,0-.6-1c-2-3.21-5-5.72-7.26-8.78-.74-1-1.31-1.82-2.61-2-1.92-.29-2.89.79-4.25-1-.37-.49-1-.94-1.55-.65.14.39.28.77.42,1.17a.53.53,0,0,1,0,.25c0,.27-.44.34-.67.19a2.2,2.2,0,0,1-.51-.65,1.9,1.9,0,0,0-2.77-.22,1,1,0,0,0-.61-.85,1.27,1.27,0,0,1-1.59,1c-.11-.35.53-.41.75-.71s0-.67-.3-.91a4.07,4.07,0,0,0-2.54-1,3.57,3.57,0,0,1-1.73-.21c-.3-.17-.51-.46-.81-.62a2.26,2.26,0,0,0-2.11.32,4.14,4.14,0,0,0-2.13,2.07c-.32,1,.39,2.26,1.4,2.13a2.08,2.08,0,0,1,.78-.08.93.93,0,0,1,.55.88,2.64,2.64,0,0,0,.17,1.08c.17.32.7.48.91.18a2,2,0,0,0,.29-1.85,2.43,2.43,0,0,1,.14-1.88c.39-.53,1.49-.36,1.42.29,0,.38-.48.65-.47,1s.5.6.9.58a4.72,4.72,0,0,1,1.18-.06c.39.1.7.6.42.88-.48.54-1.74-.39-2,.29-.07.17,0,.37,0,.55,0,.57-.76.77-1.33.84a3.15,3.15,0,0,1-1.7-.12,1.05,1.05,0,0,1-.57-1.4.65.65,0,0,0-.89.32,1.78,1.78,0,0,0-.07,1.05c-.6-.13-1.15.38-1.49.88s-.68,1.09-1.27,1.27-1.41-.06-1.72.47c-.4.69.76,1.57.36,2.25-.24.39-.8.38-1.24.5a1.87,1.87,0,0,0-.78,2.92,2.3,2.3,0,0,0,3.24,0,9.91,9.91,0,0,0,1.25-2.14,2,2,0,0,1,2-1.13,2.76,2.76,0,0,1,.83.52l1.17,1a1,1,0,0,1,.5.79c0,.26-.23.46-.31.7-.25.7.77,1.36,1.41,1a1.37,1.37,0,0,0,.27-1.95c-.6-.83-2-1.25-1.93-2.27.69-.57,1.8,0,2.2.83s.42,1.74.77,2.56,1.3,1.56,2.1,1.16c-.21-.72-.41-1.43-.62-2.13.51-.38,1.1.72,1.71.54.38-.12.42-.65.26-1a4.6,4.6,0,0,1-.52-1,1.19,1.19,0,0,1,1.39-1.21,1.82,1.82,0,0,1,1.37,1.48,3.32,3.32,0,0,0,.18.83c.27.55,1,.72,1.54,1s1.17.8.93,1.36c-.11.25-.38.49-.28.74s.42.32.42.56-.17.28-.32.34c-.39.15-.81.21-1.18.39a1,1,0,0,0-.68.93c0,.57.74.85,1.06,1.33s.27,1.06.47,1.58a5.71,5.71,0,0,0,.88,1.26c1,1.3,1.19,3,1.67,4.52.21.7.59,1.48,1.31,1.61a2.29,2.29,0,0,0,1.17-.22,7,7,0,0,0,2.85-1.69,2.35,2.35,0,0,0,.23-3,.6.6,0,0,0-.36-.22,1.1,1.1,0,0,0-.54.19,1.58,1.58,0,0,1-1.63-.35,4.58,4.58,0,0,1-1-1.43c-.28-.57-.57-1.15-.86-1.72a1,1,0,0,1,1.25.11,6.64,6.64,0,0,1,.85,1,5.44,5.44,0,0,0,3.67,1.7,3.39,3.39,0,0,1,1,.22c1,.46,1.33,2,2.42,2.29a5.59,5.59,0,0,1,.92.21,1.65,1.65,0,0,1,.78,1.14,18.28,18.28,0,0,0,.68,2.54,2.37,2.37,0,0,0,2,1.55,2.08,2.08,0,0,0,1.48-.65h0c.05-.8.07-1.59.07-2.4C140.88,372.58,140.88,372.42,140.87,372.25Z",
    style: {
      transformOrigin: "121.594px 359.915px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 101.72,
    y: 411.81,
    width: 4.73,
    height: 16.64,
    fill: "#263238",
    style: {
      transformOrigin: "104.085px 420.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M104.08,412.87C81.43,412.87,63,394.63,63,372.22a40.62,40.62,0,0,1,21.16-35.56l.45-.25,2.75,3.8-1,.69-2.13-3a39.47,39.47,0,0,0-20.1,34.28c0,21.76,17.91,39.47,39.91,39.47a40.25,40.25,0,0,0,25-8.74l-1.66-1.64.83-.84,2.59,2.56-.5.42A41.43,41.43,0,0,1,104.08,412.87Z",
    fill: "#263238",
    style: {
      transformOrigin: "96.9px 374.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 85.2,
    y: 428.45,
    width: 36.4,
    height: 2.81,
    fill: "#263238",
    style: {
      transformOrigin: "103.4px 429.855px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeAnimate);
export default __webpack_public_path__ + "static/media/knowledge-animate.e08764a19a7bcd9cf80685f2b93e5c34.svg";
export { ForwardRef as ReactComponent };